import { defineComponent } from 'vue';
import i18nGlobal from '@/i18ns/i18n';
const i18n = i18nGlobal.global;
import { MSConstant } from '@/commons/wildcards/index.js';
import store from '@/stores/store';
import { ModuleContext, ModuleDbOption } from '@/stores/moduleConst';
import _ from 'lodash';
import moment from 'moment';
import { showError, showAlertEscapsed, showErrorEscapsed } from '@/commons/globalMessage';
import { useRoute, useRouter } from 'vue-router';
import i18nEnum from '@/i18ns/vi/i18nEnum';
import popupUtil from '@/commons/popupUtil.js';
import reportSettingAPI from '@/apis/report/voucherReportPrintAPI';
import authDVC from '@/views/etreasury/processEtreasury/authDVCService.js';
import IndexedDB from '@/commons/indexedDB';
import { msFormat } from './msFormat';
import { getAppBase } from '@/commons/utils/urlUtil';
import buTranserAPI from '@/apis/bu/bUTransferAPI';
import agreementContractApi from '@/apis/integration/integrationAgreementContractApi';
import dVCFileAPI from '@/apis/dvc/dVCFileAPI.js';
import drivenApi from '@/apis/convert/drivenApi';
import databaseAPI from '@/apis/system/databaseAPI.js';
import accountAPI from '@/apis/other/accountAPI';
import integrationACTApi from '@/apis/integration/integrationACTApi';
import notificationAPI from '@/apis/other/notificationAPI.js';
import registerAPI from '@/apis/system/registerAPI';
import EventBusGlobal, {GlobalEventName} from '@/commons/eventBusGlobal';

/**
 * Class chứa các function dùng chung cho hệ thống phía client
 */
class CommonFunction {
  countMark = 0;

  /**
   * Hiển thị thông báo khi kết nối Bumas bị ngắt
   * bhtuyen 23.01.2024
   */
  async checkConnectBumas() {
    const dbOptions = await store.dispatch('dbOption/getDbOptions', {reload: true});
    if (dbOptions?.UseBumas === false || dbOptions?.UseBumas == null) {
      // đường dẫn khi muốn gia hạn
      var link = '';
      // show popup thông báo
      var msg =
        '<div>Không kết nối được <span class="bold color-green">MISA Bumas</span> do đơn vị đã hết quyền sử dụng.</div>' +
        '<div>Vui lòng mua gói/gia hạn để tiếp tục sử dụng <a style="color: #0078D7; text-decoration: underline;" href="' +
        this.processXssValue(link) +
        '">tại đây</a>.</div>';
      showError(msg, 'Không thể lấy dữ liệu');
      return false;
    }
    return true;
  }

  getMainLoading() {
    let el = document.body.querySelector('#mloading');
    return el;
  }
  mask(important) {
    important && this.countMark++;
    let el = this.getMainLoading();
    if (el) {
      el.style.display = 'flex';
    }
  }
  unmask(important) {
    important && this.countMark--;

    if (!this.countMark) {
      let el = this.getMainLoading();
      if (el) {
        el.style.display = 'none';
      }
    }
  }
  infoLogging() {}
  errorLogging() {}
  handleException(error, showAlertEscapsed) {
    console.error(error);

    if (showAlertEscapsed) {
      const localize = i18n;
      showError(localize.t('i18nCommon.GlobalErrorMessage'));
    }
  }

  /**
   * Xử lý hiển thị dialog
   * @author DNThang - 30.10.2019
   * DNThang - 06.05.2020: Trong trường hợp owner là popup thì sẽ append vào content để không bị chìm ở dưới
   */
  prepareForDialog(component, owner, options) {
    if (owner && component) {
      var frmType = defineComponent({extends: component}),
        frm = new frmType(options);

      frm.$mount();

      if (owner.isMsPopup) {
        let contentElement = owner.$refs.popupx; //owner.$el.querySelector('.ms-popup-content.ms-popup');
        contentElement.appendChild(frm.$el);
      } else {
        if (owner instanceof Element) {
          owner.appendChild(frm.$el);
        } else {
          owner.$el.appendChild(frm.$el);
        }
      }

      return frm;
    }

    return;
  }
  /**
   * Build vue key cho data
   */
  genVKeyValue(data, field = '__vKeyValue') {
    if (data) {
      data.forEach(item => {
        item[field] = this.generateUUID();
      });
    }
  }
  /**
   *  Tạo uuid
   *  Create by: pvduong1 - 30/08/2019
   */
  generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      let d = new Date().getTime();
      d += performance.now();
      let r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
  }
  /**
   * Guild empty
   */
  generateEmptyUUID() {
    return '00000000-0000-0000-0000-000000000000';
  }
  /**
   * Kiểm tra 2 đối tượng có phải là cha con của nhau không
   */
  hasParent(child, parent) {
    if (child.parentElement) {
      if (child.parentElement === parent) {
        return true;
      } else {
        return this.hasParent(child.parentElement, parent);
      }
    }

    return false;
  }

  /**
   * Show các trường hợp trả ra của QLTS
   * ntloc 1/7/2024
   */
  showRespondFromQLTS(res, proxy) {
    if (res.Status == 0 && res.Data == 2) {
      proxy.$toast.error('Thiếu thông tin bắt buộc: SecretKey, OrganizationCode');
    } else if (res.Status == 0 && res.Data == 3) {
      proxy.$toast.error('Không tìm thấy Mã QHNS của đơn vị');
    } else if (res.Status == 0 && res.Data == 4) {
      let link = window._qlts.linkHelpQLTS;
      showErrorEscapsed(proxy.$tm('i18nBaseForm.Message.ExpiredQLTSConnected'), [link], 'Không thể lấy dữ liệu');
    }
  }

  /**
   * Kiểm tra đối tượng có class style không
   * Modified nntam: thêm case cối vào cho không chết
   */
  hasClass(element, className) {
    if (element && element.className) {
      return element.className.indexOf(className) > -1;
    }
    return false;
  }

  shortkeyPushView(el) {
    if (!window.shortkeyView) {
      window.shortkeyView = [];
    }
    window.shortkeyView.remove(el);
    window.shortkeyView.push(el);
  }

  shortkeyPopView(el) {
    window.shortkeyView.remove(el);
  }

  shortkeyPopClass(target) {
    let el = document.querySelector(target);
    el && window.shortkeyView.remove(el);
  }

  /**
   * Xử lý render element động
   * modified by ntphong 28/5/2021 - isAppendTarget: nếu là append 1 đoạn code html vào 1 trong target
   */
  renderDynamicElement(target, component, owner, options, isAppendTarget) {
    if (component) {
      var frmType = defineComponent({extends: component}),
        frm = new frmType(options);

      frm.$mount();

      if (target && isAppendTarget && frm.$el) {
        target.appendChild(frm.$el);
      }
      return frm;
    }
  }

  /**
   * focus vào control tiếp theo
   */
  focusNextControl(curfocus) {
    var el = this.getNextInputControl(curfocus);
    if (el) {
      el.focus();
      if (typeof el.select === 'function') {
        el.select();
      }

      return true;
    }
  }

  /**
   * Kiểm tra element có hiển thị không
   * (modified) dtnga3 (04.10.2022) Đối với element có position :fixed thì phải check bằng thuộc tính display
   */
  isVisible(element) {
    if (window.getComputedStyle(element).position === 'fixed') {
      return window.getComputedStyle(element).display != 'none';
    } else {
      return element.offsetParent;
    }
  }

  /*
   * Lấy control nhập liệu tiếp theo
   */
  getNextInputControl(current) {
    let me = this,
      //i = c.index(),
      p = current.parentNode;
    if (!p) {
      return null;
    }

    let ch = p.children,
      r = null,
      o,
      i = 0;
    for (; i < ch.length; i++) {
      if (ch[i] === current) {
        break;
      }
    }

    for (var k = i + 1; k < ch.length; k++) {
      o = ch[k];
      if (
        ['INPUT', 'TEXTARE', 'BUTTON', 'A'].indexOf(o.tagName) > -1 &&
        !o.getAttribute('disabled') &&
        !o.getAttribute('tabindex') !== -1 &&
        me.isVisible(o)
      ) {
        r = o;
      } else {
        r = me.getFirstControlFocus(o);
      }

      if (r) {
        break;
      }
    }

    if (!r) {
      r = me.getNextInputControl(p);
    }

    return r;
  }
  /**
   * Lấy control nhập liệu đầu tiên
   */
  getFirstControlFocus(parent) {
    const me = this,
      obj = parent || document,
      selector = [
        'input:not([disabled]):not([tabindex="-1"])',
        'textarea:not([disabled]):not([tabindex="-1"])',
        'select:not([disabled]):not([tabindex="-1"])',
        'button:not([disabled]):not([tabindex="-1"]):not(.ms-con-dropdown)',
        'a:not([disabled]):not([tabindex="-1"]):not(.ms-collapse-item--header)',
      ].join(',');

    const items = obj.querySelectorAll(selector);
    if (items != null && items.length > 0) {
      for (let i = 0; i < items.length; i++) {
        let item = items[i];
        if (me.isVisible(item)) {
          return item;
        }
      }
    }

    return null;
  }

  /**
   * Tìm ra control Input đầu tiên theo scope truyền vào và cho phép sửa
   * @param {Element} scope Parent cần tìm input
   */
  findFirstControlInput(scope, query) {
    if (scope && scope.querySelector) {
      var input = scope.querySelector(
        query ||
          "input:not([type=button]):not([type=radio]):not([type=checkbox]):not([readonly]):not([disabled]):not([class='hidden']),textarea:not([readonly]):not([disabled]):not([class='hidden'])",
      );
      return input;
    }
    return;
  }

  /**
   * Tự động focus vào control nhập liệu đầu tiên theo scope truyền vào
   * @param {Element} scope Phạm vi cần xử lý focus
   * @author DNThang - 31.10.2019
   */
  focusFirstControlInput(scope, select = true, query) {
    var me = this;

    // setTimeout(() => {
    var input = me.findFirstControlInput(scope, query);
    if (input) {
      input.focus();

      if (select && typeof input.select === 'function') {
        input.select();
      }
    } else {
      //nếu k có input nào để focus thì focus vào dòng đầu tiên của grid( nếu có ) để có thể thực hiện phím tắt keydown up/down để chọn dòng
      me.focusFirstRowGrid(scope);
    }
    // });
  }

  /**
   * Tự động focus vào control nhập liệu đầu tiên theo scope truyền vào
   * @param {Element} scope Phạm vi cần xử lý focus
   * @author bnduc - 15.11.2019
   */
  focusFirstControl(scope) {
    if (scope) {
      const me = this;

      // setTimeout(() => {
      let input;
      if (
        scope.type === 'text' ||
        (scope.hasAttribute && scope.hasAttribute('type') && scope.getAttribute('type') === 'text')
      ) {
        input = scope;
      } else {
        input = me.findFirstControlFocus(scope);
      }

      if (input) {
        input.focus();
      }
      // });
    }
  }

  /**
   * Tự động focus vào control nhập liệu vào dòng đầu tiên của grid( nếu có ) để có thể thực hiện phím tắt keydown up/down để chọn dòng
   * @param {Element} scope Phạm vi cần xử lý focus
   * @author nnlam - 16.06.2021
   */
  focusFirstRowGrid(scope) {
    if (scope) {
      const me = this;

      // setTimeout(() => {
      let grid;
      if (me.grid) {
        grid = me.grid.$el;
      } else {
        grid = me.findFirstGrid(scope);
      }

      if (grid) {
        //me.$nextTick(() => {
        if (grid) {
          let trFirst = grid.querySelector('.ms-tbody.data tr');
          if (trFirst) {
            trFirst.focus();
          }
        }
      }
    }
  }

  /**
   * Tìm ra control Input đầu tiên theo scope truyền vào và cho phép sửa
   * @param {Element} scope Parent cần tìm input
   * @author bnduc - 15.11.2019
   */
  findFirstControlFocus(scope) {
    if (scope && scope.querySelector) {
      let input = scope.querySelector('input:not([readonly]):not([disabled]),button:not([disable]),a,textarea');
      return input;
    }
    return;
  }

  /**
   * focus vào control trước đó
   */
  focusPreviewControl(curfocus) {
    const me = this;
    let fn = function (parent) {
      let items = parent.querySelectorAll('input:not([disabled]),button:not([disable]),a');
      if (items[0] !== curfocus) {
        for (let i = 1; i < items.length; i++) {
          if (items[i] === curfocus) {
            for (let j = i - 1; j >= 0; j--) {
              //check item visible
              if (me.isVisible(items[j])) {
                items[j].focus();
                return;
              }
            }
            //reset focus to parent
            curfocus = parent;
          }
        }
      }
      fn(parent.parentElement);
    };

    fn(curfocus.parentElement);
  }

  /**
   * Tìm ra grid đầu tiên của form
   * @param {Element} scope Parent cần tìm grid
   * @author nnlam - 16.06.2021
   */
  findFirstGrid(scope) {
    if (scope && scope.querySelector) {
      let grid = scope.querySelector('.ms-grid-viewer');
      return grid;
    }
    return;
  }

  /**
   * Xử lý khi focus control cuối cùng thì sẽ thực thi fn
   */
  processUnfocusLastControl(e, fn) {
    if (e.which === 9 && !e.shiftKey) {
      //console.log(e.target.attributes.class.value);
      let cur = e.target;
      let els = e.currentTarget.querySelectorAll('*');
      var flag = true;
      for (let i = 0; i < els.length; i++) {
        if (els[i] === cur) {
          flag = false;
          continue;
        }
        if (flag) {
          continue;
        }

        els[i].focus();
        if (els[i] === document.activeElement) {
          e.preventDefault();
          return;
        }
      }

      //focus first control
      e.preventDefault();
      fn();
    }
  }

  /**
   * Kiểm tra 2 đôi tượng có khác nhau không
   */
  checkDiff(newVal, oldVal) {
    let ret = false;
    let newStr = JSON.stringify(newVal).replace(/:null,/g, ":'',");
    let oldStr = JSON.stringify(oldVal).replace(/:null,/g, ":'',");
    return newStr !== oldStr;

    // if (typeof newVal == "object" && typeof oldVal == "object") {
    //   for (let field in newVal) {
    //     if (typeof newVal[field] != "object" && newVal[field] != oldVal[field]) {
    //       ret = true;
    //       break;
    //     }
    //   }
    // }
    // return ret;
  }
  /**
   * pvduy 28/06/2021
   * lẩy ra danh sách các trường thay đổi và giá trị thay đổi
   * thêm đoạn xử lý trường hợp tìm sự thay đổi cửa giá trị datetime
   */
  getDiffListProperty(newVal, oldVal) {
    let listField = [];
    if (typeof newVal == 'object' && typeof oldVal == 'object') {
      for (let field in newVal) {
        if (typeof newVal[field] != 'object' && newVal[field] != oldVal[field]) {
          listField.push(field);
        } else if (newVal[field] instanceof Date) {
          var isChange = false;
          // nếu 2 giá trị khác nhau hoặc một trong 2 thằng null thì xác nhận sự thay đổi.
          if (
            newVal[field] != null &&
            oldVal[field] != null &&
            typeof newVal[field].getTime == 'function' &&
            typeof oldVal[field].getTime == 'function' &&
            newVal[field].getTime() != oldVal[field].getTime()
          ) {
            isChange = true;
          } else if (
            (newVal[field] == null && oldVal[field] != null) ||
            (newVal[field] == null && oldVal[field] != null)
          ) {
            isChange = true;
          }
          if (isChange) {
            listField.push(field);
          }
        }
      }
    }
    return listField;
  }

  //Chuyển dữ liệu thành dạng tree
  // Created by LTDAT(16.06.2020)
  // Collap hết nếu số dòng quá lớn >200 : NCPHUOC 20/05/2020
  // modifiedBy dtnga3 (13.07.2023) Kiểm tra nếu dataRow chưa set expanded thì mới set mặc định là true
  nomalizeDataTree(data, idField, parentField) {
    const me = this;
    let dataTemp = [...data],
      parentNodes = [];

    const cacheList = new Map();

    //Cache lại item trước để tăng performance
    dataTemp.forEach(item => {
      item.childNodes = [];
      cacheList.set(item[idField], item);
      delete item.isParent;
    });
    // const collapseAll = data.length > MSConstant.DefaultMaxRecord.GridTree;
    dataTemp.forEach((item, index) => {
      if (item[parentField]) {
        //Tìm cha
        let parent = cacheList.get(item[parentField]);

        if (parent) {
          //NVTUAN1 01.03.2024: Sử dụng hàm hasOwnProperty không ảnh hưởng bởi PBI 419812
          if (!parent.hasOwnProperty('isParent')) {
            parent['isParent'] = true;
          }
          //NVTUAN1 01.03.2024: Sử dụng hàm hasOwnProperty không ảnh hưởng bởi PBI 419812
          if (parent.hasOwnProperty('expanded') && !parent.expanded) {
            item.expanded = false;
            item.isHide = true;
          }
          parent.childNodes.push(item);
          //Cache lại parentNode luôn
          item.parentNode = parent;
          // if (collapseAll && item.level === 2) {
          //   item.isHide = true;
          // }
        } else {
          parentNodes.push(item);
        }
      } else {
        // NMSINH: thêm món này vì nếu chọn thằng ko có Cha trong list thì nó chính là cha luôn
        parentNodes.push(item);
      }

      //NVTUAN1 01.03.2024: Sử dụng hàm hasOwnProperty không ảnh hưởng bởi PBI 419812
      if (!item.hasOwnProperty('expanded')) {
        item.expanded = true;
      }

      // if (collapseAll && item.level === 2) {
      //   item.expanded = false;
      // } else {
      //
      // }
    });
    return parentNodes;
  }

  /**
   * Thực hiện ghép các node cha đi kèm với các node con luôn để thực hiện show ra ngay bên dưới node cha
   * @param {[TreeModel]} dataResoures Danh sách các node cha cần sắp xếp
   * @param {*} expanded Có Mở rộng ra không
   * @param {*} level
   */
  getBodyData(dataResoures, expanded, level = 1, childNodes = 'childNodes', isGroup = false, customTitleGroup = null) {
    if (!dataResoures) {
      return [];
    }
    let data = [...dataResoures];
    let bodyData = [];
    for (let i = 0; i < data.length; i++) {
      const row = data[i];
      const children = row[childNodes];
      const childrenLen = Object.prototype.toString.call(children).slice(8, -1) === 'Array' ? children.length : 0;

      row.level = level;
      // Vue.set(row, "isHide", false);
      // Vue.set(row, "expanded", expanded);
      // row.isHide = false;
      // row.expanded = expanded;

      row.isSelected = false;
      row._isSelectedMultiple = false;
      //Thêm caption group
      if (isGroup && row.caption) {
        if (!customTitleGroup) {
          row.caption += ` (${childrenLen} bản ghi)`;
        } else {
          if (typeof customTitleGroup === 'function') {
            row.caption = customTitleGroup(row);
          }
        }
      }
      bodyData.push(row);
      if (childrenLen > 0) {
        row._expandable = true;
        bodyData = bodyData.concat(this.getBodyData(children, expanded, level + 1, childNodes, isGroup));
      }
    }
    return bodyData;
  }

  /**
   * Sắp xếp dữ liệu cây để con đứng ngay sau cha
   * @param {*} orderField : Sắp xếp các con cùng cấp trước sau
   */
  sortTree(data, orderby, idField, parentIdField) {
    let sort = data.sortObject(orderby);

    let res = [];
    let parents = {};
    //đẩy root vào
    for (let i = 0; i < sort.length; i++) {
      let item = sort[i],
        parentId = item[parentIdField];
      if (parentId === null || parentId === undefined) {
        res.push(item);
      }

      parents[item[idField]] = item;
    }

    //duyệt đẩy con
    //do push vào con lần lượt vào ngay sau cha -> đảo ngược lại để đúng thứ tự
    sort.reverse();
    for (let i = 0; i < res.length; i++) {
      let processItem = res[i];

      for (let j = 0; j < sort.length; j++) {
        let item = sort[j];
        if (res.indexOf(item) > -1) {
          //đã duyệt
          continue;
        }

        if (item[parentIdField] === processItem[idField]) {
          let index = res.indexOf(processItem);
          //append vào vị trí sau cha
          res.splice(index + 1, 0, item);
        }
      }
    }

    //dí nốt các item chưa xử lý (có cha nhưng k tìm thấy cha)
    if (res.length < sort.length) {
      for (let j = 0; j < sort.length; j++) {
        let item = sort[j];
        if (res.indexOf(item) === -1) {
          res.push(item);
        }
      }
    }

    return res;
  }

  /**
   * Lấy giá trị enum theo text
   */
  getEnumValue(enumName, text) {
    let source = this.getEnumSource(enumName);
    let textTrim = text.trim();
    for (let i = 0; i < source.length; i++) {
      let item = source[i];
      if (textTrim === item.enumText) {
        return item.enumValue;
      }
    }

    return null;
  }

  /**
   * Lấy ra giá trị key của enum theo value
   * @param {Number} value Giá trị của enum cần lấy ra enum text
   * @param {String} enumName EnumName để get text
   */
  getEnumText(value, enumName) {
    //HTHIEP 14.03.2022: Fix tạm do thay đổi lại bộ enum, constant
    let e = MSConstant[enumName];

    if (e) {
      for (const key in e) {
        //NVTUAN1 01.03.2024: Sử dụng hàm hasOwnProperty không ảnh hưởng bởi PBI 419812
        if (e.hasOwnProperty(key) && e[key] === value) {
          return key;
        }
      }
    }

    return value;
  }

  /**
   * Kiểm tra nếu hết hạn license thì redirect
   * NTLOC 30.11.2022
   */
  checkRouterExpiredDate() {
    const {Context} = store.state[ModuleContext];
    let overExpiredDate = Context?.OverExpiredDate;
    const router = useRouter();
    const ignoreChecks = ['/logout', '/choose-tenant', 'login-callback', '/login'];
    if (overExpiredDate && !ignoreChecks.some(item => location.href.includes(item))) {
      router.push('/license-expire-date');
      return true;
    }
    return false;
  }

  /**
   * Lấy ra resource theo enum
   * @param {Number} value Giá trị của enum cần lấy ra enum resource
   * @param {String} enumName EnumName để get text
   */
  getEnumResource(value, enumName) {
    const me = this,
      localize = i18n;

    let key = me.getEnumText(value, enumName);
    let resourceKey = enumName + '.' + key;
    let text = localize.t('i18nEnum.' + resourceKey);
    return text;
  }

  /**
   * Lấy enumsource với tên enum truyền vào
   * @param {String} enumName Tên enum trong enumeration
   * @param {Array} values Danh sách các enum lấy ra (nếu cần chỉ định), nếu không thì sẽ lấy tất cả
   * @param {Boolean} prefixIdx Có kèm theo tiền tố index không: true - có, false - không (Mặc định không)
   * VD: getEnumSource("EnumCABAReasonType",[10,11,12,13])
   * CreatedBy: PDKIEN 15/08/2019
   */
  getEnumSource(enumName, values, prefixIdx) {
    let e = MSConstant[enumName],
      arr = [];
    if (e) {
      let idx = 0;
      for (const key in e) {
        //NVTUAN1 01.03.2024: Sử dụng hàm hasOwnProperty không ảnh hưởng bởi PBI 419812
        if (e.hasOwnProperty(key)) {
          let v = e[key],
            ix = -1;
          if (!values || (ix = values.indexOf(v)) > -1) {
            /*
             * sửa lại cách lấy dữ liệu theo enum
             * pvduy 02/02/2020
             */
            let enumText = i18n.t('i18nEnum.' + enumName + '.' + key);
            if (prefixIdx) {
              enumText = ++idx + '. ' + enumText;
            }

            let item = {
              enumValue: v,
              enumKey: key,
              enumText: enumText,
            };

            // lấy thêm tooltip
            if (i18nEnum[enumName + '_Tooltip']) {
              item.tooltip = i18nEnum[enumName + '_Tooltip'][key];
            }
            if (ix > -1) {
              // DVQUAN: sửa lại cách lấy enum source với trường hợp 9 và 99 => không lấy được 1 trong 2
              if (arr[ix]) {
                arr[arr.length] = item;
              } else {
                arr[ix] = item;
              }
            } else {
              arr.push(item);
            }
          }
        }
      }
    }
    return arr;
  }

  /**
   * Lấy tham số trên query string
   */
  getUrlParams() {
    let search;
    if (window.location.hash) {
      search = window.location.hash.substr(1);
    } else {
      search = window.location.search;
    }
    const temp = new URLSearchParams(search);
    let result = {};
    for (var value of temp.keys()) {
      result[value] = temp.get(value);
    }

    return result;
  }

  /**
   * Đăng xuất khỏi ứng dụng
   */
  logoff() {
    //giải phóng tài nguyên
    let storeDebug = store;
    let fn = [ModuleContext, 'logout'].join('/');
    store.dispatch(fn);
    // location.href = window._logoutUrl;
  }

  downloadLink(link) {
    var iframe = document.createElement('iframe');
    iframe.style.display = 'none';

    iframe.src = link;
    document.body.appendChild(iframe);
  }

  /**
   * Gán cookie
   */
  setCookie(name, value, seconds) {
    var expires = '';
    if (seconds) {
      var date = new Date();
      date.setTime(date.getTime() + seconds * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/' + '; domain=' + location.hostname;
  }

  /**
   * Đọc cookie
   */
  getCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  /**
   * Xóa cookie
   */
  removeCookie(name) {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }

  /**
   * Xử lý dữ liệu trả về từ server
   * NCPHUOC 19/08/2022: Check xem có đúng là date không thì mới gắn data
   */
  processServerResponseData(data) {
    if (data) {
      const rgDate = /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d/;
      const rgDateTime = /^\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d(.)?(\d{0,9})?(Z)?(\+)?(\d{2})?(:)?(\d{2})?$/;
      for (let i in data) {
        if (data[i]) {
          if (
            typeof data[i] === 'string' &&
            // i.indexOf("Date") > -1 &&
            (rgDate.test(data[i]) || rgDateTime.test(data[i]))
          ) {
            const date = new Date(data[i]);
            if (moment(date).isValid()) {
              data[i] = new Date(data[i]);
            }
          } else if (typeof data[i] === 'object' && Object.keys(data[i].length > 0)) {
            this.processServerResponseData(data[i]);
          }
        }
      }
    }
  }

  /**
   * Lấy text hiển thị của trường thông tin
   * @param {*} field : Tên trường
   * @param {*} namespace : mã để xem có custom lại không, nếu không thì lấy mặc định
   */
  getColumnText(field, namespace) {
    const localize = i18n;
    const common = localize.messages[localize.locale]['i18nColumn'];
    const custom = namespace ? common[namespace] : null;

    //NVTUAN1 01.03.2024: Sử dụng hàm hasOwnProperty không ảnh hưởng bởi PBI 419812
    if (custom && custom.hasOwnProperty(field)) {
      return custom[field];
    }
    return common[field];
  }

  /**
   * Lấy text hiển thị của bảng
   * @param {*} table : Tên bảng
   * @param {*} namespace : mã để xem có custom lại không, nếu không thì lấy mặc định
   */
  getTableText(table, namespace) {
    const localize = i18n,
      common = localize.messages[localize.locale]['i18nTable'],
      custom = namespace ? common[namespace] : null;

    //NVTUAN1 01.03.2024: Sử dụng hàm hasOwnProperty không ảnh hưởng bởi PBI 419812
    if (custom && custom.hasOwnProperty(table)) {
      return custom[table];
    }
    return common[table];
  }
  /**
   * Maping từ html element thành đối tượng vuejs để thao tác
   * @param {object} dom html dome element
   */
  mapDomToVue(dom) {
    return dom.__vue__;
  }

  /**
   * Chuyển tiếng việt có dấu thành không dấu
   * @author ĐVThi 09/03/2021
   */
  removeVietnameseTones(str) {
    if (str) {
      str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
      str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
      str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
      str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
      str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
      str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
      str = str.replace(/đ/g, 'd');
      str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, 'A');
      str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, 'E');
      str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, 'I');
      str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, 'O');
      str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, 'U');
      str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, 'Y');
      str = str.replace(/Đ/g, 'D');
      // Some system encode vietnamese combining accent as individual utf-8 characters
      // Một vài bộ encode coi các dấu mũ, dấu chữ như một kí tự riêng biệt nên thêm hai dòng này
      str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ''); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
      str = str.replace(/\u02C6|\u0306|\u031B/g, ''); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
      // Remove extra spaces
      // Bỏ các khoảng trắng liền nhau
      str = str.replace(/ + /g, ' ');
      str = str.trim();
      // Remove punctuations
      // Bỏ dấu câu, kí tự đặc biệt
      //str = str.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g," ");
      return str;
    } else {
      return '';
    }
  }

  buildFilterParam(filters) {
    let me = this,
      sFilter = '';

    if (filters && !(filters instanceof Array)) {
      filters = [filters];
    }

    let length = filters.length;

    if (length > 0) {
      let i,
        arrayFilters = [],
        sJoin = ',';

      for (i = 0; i < length; i++) {
        let filter = filters[i],
          sChildFilter = '',
          operandChild = 'and';

        if (filter.childrens instanceof Array && filter.childrens.length > 0) {
          let childFirst = filter.childrens[0];
          if (childFirst.operand) {
            operandChild = childFirst.operand;
          }

          sChildFilter = me.buildFilterParam(filter.childrens);
        }

        let s = '"' + filter.property + '",' + (filter.operator ? '"' + filter.operator + '",' : ''),
          //Mặc định operand là `and`
          operand = '"and"';

        s += me.nomalizeFilterValue(filter.operator, filter.value);
        //xử lý tình huống muôn filter = 0/false nhưng muốn lọc ra cả các giá trị null
        if (filter.nullToFail && (filter.value === 0 || filter.value === false)) {
          s += ',true';
        }

        s = '[' + s + ']';

        if (sChildFilter) {
          s = '[' + s + ',"' + operandChild + '",' + sChildFilter + ']';
        }

        if (i !== 0) {
          if (filter.operand) {
            operand = '"' + filter.operand + '"';
          }
          arrayFilters.add(operand);
        }
        arrayFilters.add(s);
      }

      sFilter = arrayFilters.join(sJoin);
      if (length > 1) {
        sFilter = '[' + sFilter + ']';
      }
    }

    return sFilter;
  }

  nomalizeFilterValue(operator, value) {
    var ret = '';
    switch (operator) {
      case 'in':
      case 'notin':
        ret = JSON.stringify(value);
        break;
      default:
        if (typeof value === 'number') {
          ret = value.toString();
        } else if (typeof value === 'boolean') {
          ret = value;
        } else if (value instanceof Date) {
          if (value.getHours() === 0 && value.getMinutes() === 0 && value.getSeconds() === 0) {
            ret = ['"', moment(value).format('YYYY-MM-DD'), 'T00:00:00"'].join('');
          } else {
            ret = ['"', moment(value).format('YYYY-MM-DDThh:mm:ss'), '"'].join('');
          }
        } else {
          ret = ['"', value, '"'].join('');
        }
    }

    return ret;
  }

  /**
   * Xử lý tham số trước khi gọi lên server load dữ liệu cho combobox
   */
  processComboboxParamRequest(param) {
    const me = this;
    for (let i in param) {
      let value = param[i];
      switch (i) {
        case 'filter':
          //chuẩn hóa tham số filter
          if (Array.isArray(value) && value.length > 0) {
            value = me.buildFilterParam(value);
          } else {
            continue;
          }
          break;
      }
      param[i] = value;
    }
  }

  /**
   * hàm kiểm tra giá trị null, string.Empty, undefined
   * a và b thuộc 3 giá trị trên thì bằng nhau
   * NXCHIEN 27.12.2023
   */
  compareStringSpecial(a, b) {
    if (!a && !b) {
      return true;
    }
    return false;
  }

  setLocalStorage(key, value) {
    localStorage.setItem(this.processLocalStorageKey(key), value);
  }

  getLocalStorage(key) {
    return localStorage.getItem(this.processLocalStorageKey(key));
  }

  removeLocalStorage(key) {
    localStorage.removeItem(this.processLocalStorageKey(key));
  }

  processLocalStorageKey(key) {
    return [window._appConfig.localStoragePrefix, key].join('');
  }

  setSessionStorage(key, value) {
    sessionStorage.setItem(key, value);
  }

  getSessionStorage(key) {
    return sessionStorage.getItem(key);
  }

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  checkFullMonth(fromDate, toDate) {
    let shortText = '',
      localize = i18n;
    if (fromDate && toDate) {
      if (fromDate.getDate() == 1) {
        let fromYear = fromDate.getFullYear(),
          fromMonth = fromDate.getMonth();
        let toYear = toDate.getFullYear(),
          toMonth = toDate.getMonth();
        let daysOfMonth = 32 - new Date(toYear, toMonth, 32).getDate();
        if (toDate && daysOfMonth == toDate.getDate()) {
          if (fromMonth == toMonth && fromYear == toYear) {
            shortText = localize.t('i18nReport.ReportTerm').format(fromMonth + 1, fromYear);
          } else if (fromMonth < toMonth && fromYear == toYear) {
            shortText = localize.t('i18nReport.ReportTermRange').format(fromMonth + 1, toMonth + 1, fromYear);
          }
          return shortText;
        }
      }
    }
    return shortText;
  }

  helpAms(helpId) {
    return [window._external.amisAmsHelp, helpId].join('');
  }

  /**
   * Func bỏ dấu tiếng việt
   * @param {String} str
   * @author NCThanh1
   */
  removeUnicode(str) {
    let tmp = str;
    tmp = tmp.toLowerCase();
    tmp = tmp.normalize();
    tmp = tmp.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
    tmp = tmp.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
    tmp = tmp.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
    tmp = tmp.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
    tmp = tmp.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
    tmp = tmp.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
    tmp = tmp.replace(/đ/g, 'd');
    tmp = tmp.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|´|-|{|}|\||\\/g, ' ');
    tmp = tmp.replace(/[^a-zA-Z0-9 ]/g, '');
    tmp = tmp.replace(/ + /g, ' ');
    tmp = tmp.trim();
    return tmp;
  }

  /**
   * Load dữ liệu combobox
   */
  getCacheComboboxData(type, payload, loadPromise, loadScope) {
    let key = [type, JSON.stringify(payload)].join('_').toLowerCase(),
      cache = window._cboData[key];

    return new Promise(resolve => {
      if (cache) {
        resolve(cache);
        return;
      }

      loadPromise.call(loadScope, payload).then(result => {
        window._cboData[key] = result;
        resolve(result);
      });
    });
  }

  /**
   * Load dữ liệu combobox
   */
  removeCacheComboboxData(key) {
    const caches = window._cboData;
    if (caches) {
      var keys = [];
      if (Array.isArray(key)) {
        keys = key;
      } else if (typeof key === 'string') {
        keys.push(key);
      } else {
        keys.push(String(key));
      }

      keys.forEach(item => {
        let key = [item, ''].join('_').toLowerCase(),
          removeKeys = [];
        for (let i in caches) {
          if (i.indexOf(key) === 0) {
            removeKeys.push(i);
          }
        }

        for (let i = 0; i < removeKeys.length; i++) {
          let cacheKey = removeKeys[i];
          delete caches[cacheKey];
        }
      });
    }
  }

  /**
   * Tách từ khóa tìm kiếm thành các từ theo quy tắc
   * 1. Nếu có ngoặc kép "" thì tìm đúng kí tự trong ngoặc kép
   * 2. Nếu không thì chỉ cần chứa cả 2 kí tự là đủ
   * @param {string} keyword từ khóa tìm kiếm
   * @author NVLAM 23.11.2020
   */
  splitKeyWord(keyword) {
    let wordArr = [];
    if (typeof keyword !== 'string') {
      keyword = _.toString(keyword);
    }
    let firstDoubleQuoteIdx = keyword.indexOf('"'),
      lastDoubleQuoteIdx = keyword.lastIndexOf('"');
    /**
     * Các TH tìm kiếm full text
     * 1. Đây là foo
     * 2. "Đây là foo
     * 3. Đây "là foo"
     * 4. "Đây là" foo
     */
    if (
      firstDoubleQuoteIdx === -1 ||
      firstDoubleQuoteIdx === lastDoubleQuoteIdx ||
      firstDoubleQuoteIdx !== 0 ||
      lastDoubleQuoteIdx !== keyword.length - 1
    ) {
      wordArr = keyword.split(/\s+/); //tách theo dấu cách
    } else {
      let fullText = keyword.slice(firstDoubleQuoteIdx + 1, lastDoubleQuoteIdx);
      if (!_.isEmpty(fullText)) {
        wordArr.push(fullText);
      }
    }
    // for (let i = 0; i < wordArr.length; ++i) {
    //     wordArr[i] = wordArr[i].replace(/[^a-z\d]/g, '\\$&');//chèn thêm 1 kí từ
    // }
    return wordArr;
  }

  /**
   * hàm search local
   * properties: danh sách các trường cần search
   * searchText: text nhập ở ô search
   * source: dữ liệu gốc dùng để filter
   * grid: grid filter
   */
  filterFn(properties, source, grid, searchText, form) {
    let data = [],
      me = this;
    let sourceTemp = [];
    if (Array.isArray(source)) {
      Object.assign(sourceTemp, source);
      if (searchText && searchText != '') {
        sourceTemp.forEach(item => {
          if (
            me.checkSearchText(item, properties, searchText) &&
            me.checkFilterHeader(item, grid) &&
            form.checkFilterGridTreeCustom(item, properties, searchText)
          ) {
            if (data.indexOf(item) === -1) {
              data.push(item);
            }
            if (grid && grid.isGridTree) {
              me.findParentNode(source, data, item, form);
            }
          }
        });
      } else {
        data = sourceTemp;
      }
    }
    if (form.filterHeader && form.filterHeader.length > 0) {
      grid.dataTemp = data;
    } else {
      grid.dataTemp = source;
    }
    return data;
  }

  /*
   *  Hàm tìm kiếm các node cha khi thực hiện tìm kiếm dữ liệu.
   *  pvduy 06/01/2021
   */
  findParentNode(items, filterItems, itemChild, form) {
    let me = this;
    let key = '',
      parentKey = 'ParentID';
    if (form && form.grid && form.grid.idProperty) {
      key = form.grid.idProperty;
    }
    if (form && form.grid && form.grid.parentIdProperty) {
      parentKey = form.grid.parentIdProperty;
    }
    items.forEach(item => {
      if (item[key] == itemChild[parentKey] && !filterItems.find(x => x[key] == item[key])) {
        if (filterItems.indexOf(item) === -1) {
          filterItems.push(item);
        }
        me.findParentNode(items, filterItems, item, form);
      }
    });
  }
  /**
   * hàm filter col
   */
  checkFilterHeader(item, grid) {
    let listFilterHeader = [],
      check = true;
    listFilterHeader = grid.getFilterHeader(true);
    if (listFilterHeader.length > 0) {
      listFilterHeader.forEach(filter => {
        let value = filter.value ? (filter.value + '').toLowerCase() : '';
        switch (filter.operator) {
          case MSConstant.FilterOperator.Contains:
            if (!(item[filter.property] ? item[filter.property].toLowerCase() : '').contains(value)) {
              check = false;
              return false;
            }
            break;
          case MSConstant.FilterOperator.Notcontains:
            if ((item[filter.property] ? item[filter.property].toLowerCase() : '').contains(value)) {
              check = false;
              return false;
            }
            break;
          case MSConstant.FilterOperator.StartsWith:
            if (!(item[filter.property] ? item[filter.property].toLowerCase() : '').startsWith(value)) {
              return false;
            }
            break;
          case MSConstant.FilterOperator.EndsWith:
            if (!(item[filter.property] ? item[filter.property].toLowerCase() : '').endswith(value)) {
              check = false;
              return false;
            }
            break;
          case MSConstant.FilterOperator.Equals:
            if (item[filter.property] != filter.value) {
              check = false;
              return false;
            }
            break;
          case MSConstant.FilterOperator.NotEquals:
            if (item[filter.property] == filter.value) {
              check = false;
              return false;
            }
            break;
          case MSConstant.FilterOperator.GreaterThan:
            if (item[filter.property] <= filter.value) {
              check = false;
              return false;
            }
            break;
          // case MSConstant.FilterOperator.GreaterThan:
          //   if(item[filter.property] < filter.value){
          //     check = false;
          //     return false;
          //   }
          //   break;
          case MSConstant.FilterOperator.LessThan:
            if (item[filter.property] >= filter.value) {
              check = false;
              return false;
            }
            break;
          case MSConstant.FilterOperator.LessThanEquals:
            if (item[filter.property] > filter.value) {
              check = false;
              return false;
            }
            break;
          case MSConstant.FilterOperator.Between:
            //if(item[filter.property] > filter.value){
            check = false;
            return false;
            //}
            break;
          case MSConstant.FilterOperator.Null:
            if (item[filter.property]) {
              check = false;
              return false;
            }
            break;
          case MSConstant.FilterOperator.NotNull:
            if (!item[filter.property]) {
              check = false;
              return false;
            }
            break;
        }
      });
    }
    return check;
  }
  /**
   * hàm search theo text
   */
  checkSearchText(item, properties, searchText) {
    let me = this,
      check = false;

    if (searchText) {
      let text = searchText.toLowerCase();
      if (Array.isArray(properties)) {
        properties.forEach(field => {
          if (item[field] && item[field].toString().toLowerCase().contains(text)) {
            check = true;
            return;
          }
          //tìm kiếm theo ngày
          //modified LBThanh 29/11/2023
          else if (item[field] instanceof Date) {
            if (msFormat.formatDate(item[field]).toLowerCase().contains(text)) {
              check = true;
              return;
            }
          }
        });
      }
    } else {
      return true;
    }
    return check;
  }

  /**
   * Hàm search theo bộ lọc khác (vd theo dõi/ ngừng theo dõi,...)
   */
  checkFilterObject(item, filter) {
    let check = false;

    if (item && filter) {
      let props = Object.keys(filter);

      if (filter && props) {
        props.forEach(field => {
          if (
            item[field] != null &&
            item[field] != undefined &&
            filter[field] != null &&
            filter[field] != undefined &&
            item[field].toString().toLowerCase().contains(filter[field].toString().toLowerCase())
          ) {
            check = true;
            return;
          }
        });
      } else {
        return true;
      }
    }
    return check;
  }

  /**
   * Lấy thông tin phiên đăng nhập
   */
  getContext() {
    const windowKey = '_context';
    let context = window[windowKey];
    if (!context) {
      context = this.getLocalStorage('Context');
      if (context) {
        window[windowKey] = context = JSON.parse(context);
      }
    }

    return context;
  }

  /**
   * xử lý string trước khi render để chống xss
   */
  processXssValue(value) {
    if (typeof value === 'string') {
      // return value.replace(/</g, '&lt');
      return _.escape(value);
    }

    return value;
  }

  /**
   * Xử lý nội dung dữ liệu trước khi binding để tránh tấn công xss
   */
  processXss(item) {
    const me = this;
    let fn = function (obj, lv) {
      lv = lv || 0;
      for (let i in obj) {
        let v = obj[i];
        if (v) {
          if (typeof v === 'string') {
            obj[i] = me.processXssValue(v);
          } else if (typeof v == 'object' && lv < 10 && Object.keys(v).length > 0) {
            fn(v, lv + 1);
          }
        }
      }
    };
    if (Array.isArray(item)) {
      item.forEach(n => {
        fn(n);
      });
    } else if (typeof item === 'object') {
      fn(item);
    }
  }

  /**
   * ldduy 15.1.2024 bỏ thẻ hết thẻ html xung quanh đi chỉ giữ lại content của chuỗi
   * @param {param} htmlString
   * @returns
   */
  filterContentInHtmlString(htmlString) {
    let parser = new DOMParser();
    let doc = parser.parseFromString(htmlString, 'text/html');
    return doc.body.textContent;
  }

  /**
   * Loại bỏ thẻ script để tránh lỗi xss mà vẫn dùng được v-html
   * NCPHUOC 22/02/2023
   */
  removeScriptTags(input) {
    // Regular expression pattern to match script tags
    const pattern = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;

    // Replace all occurrences of the pattern with an empty string
    return input.replace(pattern, '');
  }

  /**
   * Xử lý tham số date
   * Xử lý dữ liệu trước khi ném lên server
   * Xử lý để k dính lỗi múi giờ
   */
  processDateParam(param, isDateFn) {
    for (let i in param) {
      let value = param[i];

      if (value && isDateFn(value)) {
        param[i] = moment(value).format('YYYY-MM-DD');
      }
    }
  }

  /**
   * Kiểm tra giá trị có phải là date không
   * @param {*} date
   * @returns
   * NXCHIEN 07.02.2023
   */
  isDate(date) {
    return moment(date, moment.ISO_8601, true).isValid();
  }

  /**
   * Lấy đường dẫn đầy đủ cho form link
   */
  getFullLink(formLink) {
    let url = [];
    const base = getAppBase();
    if(base){
      url.push(base);
    }
    if (location.pathname.toLocaleLowerCase().indexOf('/app/') === 0) {
      url.push('/app');
    }
    url.push(formLink);
    return url.join('');
  }

  /**
   * Lấy tên báo cáo
   */
  getReportName(reportId, defaultName) {
    const localize = i18n,
      key = 'i18nReport.name.' + reportId;

    let text = localize.t(key);
    return text === key ? defaultName || null : text;
  }

  /**
   * Xóa các phần tử trùng field trong mảng
   * @author: nnnam - 19/11/2020
   * @param {Array} arr Mảng cần distinct
   * @param {...string} args Trường key xác định distinct
   */
  distinct(arr = [], ...args) {
    let result = [];
    if (args.length) {
      result = arr.filter(function (value, index, self) {
        /** Kiểm tra index phần từ đầu tiên thỏa mãn có phải phần tửu hiện tại (không thì loại bỏ) */
        return (
          self.findIndex(function (x) {
            /** Lấy phần từ đầu tiên thỏa mãn */
            return args.every(field => x[field] == value[field]);
          }) === index
        );
      });
    } else {
      /** Mảng chứa mapping sang json để so sánh */
      let arrJson = arr.map(x => JSON.stringify(x));
      /** Loại bỏ các item giống nhau */
      arrJson = [...new Set(arrJson)];
      result = arrJson.map(x => x && JSON.parse(x));
    }
    return result;
  }

  /**
   * Viết hoa chữ cái đầu
   * @author nnnam - 5/3/2021
   * @param {any} str
   */
  capitalize(str) {
    return str ? str[0].toUpperCase() + str.substring(1) : str;
  }

  /**
   * Đọc số thành chữ
   * @author nnnam - 5/3/2021
   * @param {number} num
   */
  sayNumber(num) {
    if (num) {
      let sayNumber = '';
      let maxLength = 15;
      let length = num.toString().length;
      let strNum = ['không', 'một', 'hai', 'ba', 'bốn', 'năm', 'sáu', 'bảy', 'tám', 'chín', 'mười'];

      /**
       * Đọc 1 nhóm số gồm 3 chữ số
       * @author nnnam - 5/3/2021
       * @param {string} grNum
       */
      let sayAGroupDigit = grNum => {
        let sayNums = [];
        if (grNum != '000') {
          let says = ['trăm', 'mươi', ''];
          let nums = grNum.split('').reverse();
          nums.length = 3;
          nums = nums.reverse().map(x => parseInt(x));
          let sayGrNum = nums.map(x => strNum[x]);

          let numHundred = nums[0];
          let numDozen = nums[1];
          let numUnit = nums[2];

          if (numHundred == 0 || numDozen != 0 || numUnit != 0) {
            if (numHundred != undefined) {
              sayNums.push(strNum[numHundred] + ' ' + says[0]);
            }

            if (numDozen != undefined) {
              switch (numDozen) {
                case 0:
                  sayNums.push('linh');
                  break;
                case 1:
                  sayNums.push('mười');
                  break;
                default:
                  sayNums.push(strNum[numDozen] + ' ' + says[1]);
                  break;
              }
            }

            if (numUnit) {
              if (numUnit == 1 && numDozen != 0 && numDozen != 1 && numDozen != undefined) {
                sayNums.push('mốt');
              } else {
                sayNums.push(strNum[numUnit]);
              }
            }
          } else {
            if (numHundred) {
              sayNums.push(strNum[numHundred] + ' ' + says[0]);
            }
          }
        }

        return sayNums.filter(x => x).join(' ');
      };

      /**
       * Chia chuỗi số thành các nhóm 3 chữ số
       * @author nnnam - 5/3/2021
       * @param {string} value
       */
      let splitNumber = function group(value) {
        return value.match(/\d{1,3}(?=(\d{3})*$)/g);
      };

      let countGr = parseInt((length - 1) / 3);
      let grUnit = ['', 'nghìn', 'triệu', 'tỷ', 'nghìn'];
      let splitNum = splitNumber(num.toString()).map((x, i) => sayAGroupDigit(x) + ' ' + grUnit[countGr - i]);
      sayNumber = this.capitalize(splitNum.join(' ').trim());
      return sayNumber;
    } else {
      return 'Không';
    }
  }

  /**
   * Cách đọc số thứ tự
   * @author nnnam - 5/3/2021
   * @param {any} num
   */
  sayOrder(num) {
    if (num == 1) {
      return 'Nhất';
    } else {
      return this.sayNumber(num);
    }
  }

  /**
   * Format số
   * @param {number} num
   * @param {number} count
   */
  formatNumberToString(num, len) {
    let result = num.toString();
    let count = result.length;
    if (num != 0 && count < len) {
      result = '0'.repeat(len - count) + num;
    }
    return result;
  }

  /**
   * Tính toán theo phép tính
   * @author nnnam - 11/6/2021
   * @param {number} a
   * @param {number} b
   * @param {any} operation
   */
  calculateOperation(a, b, operation) {
    switch (operation) {
      case '+':
        return a + b;
      case '-':
        return a - b;
      case '*':
        return a * b;
      case '/':
        return a / b;
    }
  }

  /**
   * Group by theo key
   * @author nnnam - 2/6/2021
   * @param {Array} list
   * @param {any} key
   */
  groupBy(list, key) {
    return list.reduce((obj, item) => {
      obj[item[key]] = [...(obj[item[key]] || []), item];
      return obj;
    }, {});
  }

  /**
   * Tính tổng các số của các đối tượng trong mảng
   * @author nnnam - 2/6/2021
   * @param {Array} list Mảng
   * @param {Array} notNumberFields Các trường group
   */
  summary(list, groupFields, numberFields) {
    list = list || [];
    let first = list[0];

    if (first) {
      /** Mặc định các trường group không phải number */
      groupFields = groupFields || Object.keys(first).filter(key => typeof first[key] != 'number');
      /** Các trường summary không group
       *  @type Array */
      numberFields = numberFields ?? Object.keys(first).filter(key => !groupFields.includes(key));
      /** Lưu json của key */
      let jsonObj = {};
      /** Lấy mảng chứa object key của mảng */
      let mapData = this.distinct(
        list.map((item, i) => {
          let obj = groupFields.reduce((o, key) => {
            o[key] = item[key];
            return o;
          }, {});
          let key = JSON.stringify(obj);
          jsonObj[key] = [...(jsonObj[key] || []), item];
          return obj;
        }),
      );

      /** Tính tổng từng group */
      mapData.forEach(o => {
        let dataGroup = jsonObj[JSON.stringify(o)];
        /** Tính tổng từng thuộc tính trong group */
        numberFields.forEach(field => {
          o[field] = dataGroup.map(x => x[field]).reduce((sum, x) => sum + x, 0);
        });
      });

      return mapData;
    } else {
      return [];
    }
  }

  /**
   * Group mảng theo key
   * @author nnnam - 14/6/2021
   * @param {Array} arr Mangr
   * @param {Function} fnKey Function key
   */
  getGroupByFuncKey(arr, fnKey) {
    return arr.reduce((obj, x) => {
      let key = JSON.stringify(fnKey(x));
      obj[key] = [...(obj[key] || []), x];
      return obj;
    }, {});
  }

  /**
   * Group mảng theo key
   * @author nnnam - 14/6/2021
   * @param {Array} arr Mangr
   * @param {Function} fnKey Function key
   */
  mapGroupByFuncKey(arr, fnKey) {
    return arr.reduce(
      (obj, x) => {
        let key = JSON.stringify(fnKey(x));
        let o = obj.Object[key] || JSON.parse(key);
        obj.Object[key] = o;
        obj.Stack.set(o, [...(obj.Stack.get(o) || []), x]);
        return obj;
      },
      {Stack: new Map(), Object: {}},
    ).Stack;
  }

  /**
   * Fill tất cả các property của các đối tượng trong mảng
   * @author nnnam - 14/6/2021
   * @param {Array} list Mảng
   */
  fillAllProperties(list) {
    /** Clone mảng */
    var result = _.cloneDeep(list);
    /** Tất cả property của object trong mảng */
    let keys = list.reduce((arr, x) => this.distinct(arr.concat(Object.keys(x))), []);
    /** Set các thuộc tính = null */
    //NVTUAN1 01.03.2024: Sử dụng hàm hasOwnProperty không ảnh hưởng bởi PBI 419812
    list
      .filter(x => Object.keys(x).length != keys.length)
      .forEach(obj => {
        keys
          .filter(key => !obj.hasOwnProperty(key))
          .forEach(key => {
            obj[key] = null;
          });
      });

    return list;
  }

  /**
   * Join chung 2 mảng với nhau
   * @author nnnam - 14/6/2021
   * @param {Array} leftArr
   * @param {Array} rightArr
   * @param {Function} lKey
   * @param {Function} rKey
   * @param {Function} action
   * @param {Function} getKey
   */
  joinArray(leftArr, rightArr, lKey, rKey, action = (l, r) => $.extend({}, r, l), getKey) {
    /** Group 2 mảng */
    let left = this.getGroupByFuncKey(leftArr, lKey);
    let right = this.getGroupByFuncKey(rightArr, rKey);
    /** Lấy value key sau khi group */
    let keys = getKey ? getKey(left, right) : [];
    /** Join 2 bảng với nhau */
    let rs = keys.reduce((arr, key) => {
      let lVal = left[key] || [null];
      let rVal = right[key] || [null];
      /** Lấy kết quả trả về */
      lVal.forEach(l => rVal.forEach(r => arr.push(action(l, r))));
      return arr;
    }, []);

    let result = this.fillAllProperties(rs);
    return result;
  }

  /**
   * Fulljoin 2 mảng với nhau
   * @author nnnam - 14/6/2021
   * @param {Array} leftArr
   * @param {Array} rightArr
   * @param {Function} lKey
   * @param {Function} rKey
   * @param {Function} action
   */
  fullJoin(leftArr, rightArr, lKey, rKey, action = (l, r) => $.extend({}, r, l)) {
    /** Full join các key */
    return this.joinArray(leftArr, rightArr, lKey, rKey, action, (left, right) => {
      return this.distinct(Object.keys(left).concat(Object.keys(right)));
    });
  }

  /**
   * Join 2 mảng với nhau
   * @author nnnam - 14/6/2021
   * @param {Array} leftArr
   * @param {Array} rightArr
   * @param {Function} lKey
   * @param {Function} rKey
   * @param {any} action
   */
  innerJoin(leftArr, rightArr, lKey, rKey, action = (l, r) => $.extend({}, r, l)) {
    /**  Join các key trùng nhau */
    return this.joinArray(leftArr, rightArr, lKey, rKey, action, (left, right) => {
      return Object.keys(left).filter(element => Object.keys(right).includes(element));
    });
  }

  /**
   * LeftJoin 2 mảng với nhau
   * @author nnnam - 14/6/2021
   * @param {Array} leftArr
   * @param {Array} rightArr
   * @param {Function} lKey
   * @param {Function} rKey
   * @param {any} action
   */
  leftJoin(leftArr, rightArr, lKey, rKey, action = (l, r) => $.extend({}, r, l)) {
    /** Lấy key bên trái */
    return this.joinArray(leftArr, rightArr, lKey, rKey, action, (left, right) => {
      return Object.keys(left);
    });
  }

  /**
   * RightJoin 2 mảng với nhau
   * @author nnnam - 14/6/2021
   * @param {Array} leftArr
   * @param {Array} rightArr
   * @param {Function} lKey
   * @param {Function} rKey
   * @param {any} action
   */
  rightJoin(leftArr, rightArr, lKey, rKey, action = (l, r) => $.extend({}, l, r)) {
    /** Lấy key bên phải */
    return this.joinArray(leftArr, rightArr, lKey, rKey, action, (left, right) => {
      return Object.keys(right);
    });
  }

  /**
   * Tính toán lại dữ liệu cây
   * @param {Array} data Dữ liệu
   * @param {string} idField Trường ID
   * @param {string} parentField Trường Id cha
   * @param {Array} numberFields Danh sách trường cần cộng
   * @author nnnam - 25/4/2022
   */
  refreshCalculateTree(data, idField, parentField, numberFields) {
    if (data.length) {
      if (!numberFields || !numberFields.length) {
        numberFields = Object.keys(data[0]).filter(x => x.includes('Amount'));
      }

      let func = node => {
        let childs = data.filter(x => x[parentField] == node[idField]);
        childs.forEach(func);
        childs.length &&
          numberFields.forEach(field => {
            node[field] = childs.reduce((sum, x) => sum + x[field], 0);
          });
      };

      data.filter(x => !x[parentField]).forEach(func);
    }
  }

  /**
   * Tính toán lại dữ liệu cây
   * @param {Array} data Dữ liệu
   * @param {string} idField Trường ID
   * @param {string} parentField Trường Id cha
   * @param {Array} numberFields Danh sách trường cần cộng
   * @author nnnam - 25/4/2022
   */
  refreshCalculateTreeCustom(data, idField, parentField, numberFields, option) {
    if (data.length) {
      option = option || {};
      if (typeof option.filterData == 'function') {
        data = data.filter(option.filterData);
      }
      if (!numberFields || !numberFields.length) {
        numberFields = Object.keys(data[0]).filter(x => x.includes('amount'));
      }

      let func = node => {
        let childs = data.filter(x => x[parentField] == node[idField]);
        childs.forEach(func);
        childs.length &&
          numberFields.forEach(field => {
            node[field] = childs.reduce((sum, x) => sum + (x[field] || 0), 0);
          });
      };

      let roots = [];
      if (option.findRoot) {
        roots = option.findRoot(data, idField, parentField);
      } else {
        roots = data.filter(x => !x[parentField]);
      }
      roots.forEach(func);
    }
  }

  /**
   * Build config table
   * @param {Array} rows
   * @author nnnam - 28/4/2022
   */
  getConfigHeader(rows) {
    /** Số dòng */
    let len = rows.length;
    /** Đệ quy */
    let rs = rows[0].reduce(
      (obj, col) => {
        /**
         * Hàm đệ quy build config
         * @param {any} col Config cột
         * @param {any} iRow Thứ tự dòng
         * @param {any} rSpan Total rowspan
         * @param {any} skip Có bỏ qua các dòng sau không?
         */
        let func = (col, iRow, rSpan, skip) => {
          let colspan = col.colspan || 1;
          let rowspan = col.rowspan || 1;
          /** Độ dài Rowspan */
          let lenRowspan = rSpan + rowspan;

          /** Tăng thứ tự stack */
          obj.Childs[iRow] = (obj.Childs[iRow] || 0) + 1;

          /** Kiểm tra điều kiện build */
          skip = !skip && colspan == 1 && (col.field || rowspan == len - iRow);
          /** Thêm vào stack */
          skip && obj.Cols.push(col);

          /** Nếu chưa phải dòng cuối */
          if (lenRowspan < len) {
            /** Tăng thứ tự dòng */
            iRow++;
            /** Lấy trong stack thứ tự ô đã xét */
            let i = obj.Childs[iRow] || 0;
            /** Tối đã ô có thể xét */
            let maxColRow = rows[iRow].length;
            /** Đếm colspan */
            let count = 0;

            /** Tìm các config con để đệ quy */
            while (i < maxColRow && count < colspan && iRow <= len) {
              let col = rows[iRow][i++];
              count += col.colspan || 1;
              func(col, iRow, lenRowspan, skip);
            }
          }
        };

        func(col, 0, 0);

        return obj;
      },
      {
        /** Stack lưu index các ô đã xét */
        Childs: [],
        /** Lưu config build */
        Cols: [],
      },
    );

    return rs.Cols;
  }

  /**
   * Tính toán giá trị theo công thức truyền vào
   * @param {any} obj Các giá trị của các node con ({C2: 2, C3: 3})
   * @param {any} formula Công thức tính (C2 + C3)
   * @author: nnnam - 25/4/2022
   */
  calculateByFormula(obj = {}, formula) {
    let result = 0;

    if (formula) {
      let that = this;
      /** Bỏ các khoảng trắng */
      formula = formula.replaceAll(' ', '');

      let sum = ['+', '-'];
      let multi = ['*', '/'];
      /** Mảng tree đệ quy */
      let stack = [
        {
          Key: formula,
          Opera: '+',
          Parent: undefined,
          Grade: 0,
          Id: 0,
          Value: 0,
        },
      ];

      let func = (item, opera) => {
        /** Loại bỏ các dấu () đầu và cuối */
        let mat = item.Key.match(/^\((.*)\)$/);
        mat && (item.Key = mat[1]);

        /** Hash formula theo công thức */
        let tpReg = `[${opera.map(x => '\\' + x).join('|')}]\(?![^\\(]*\\)\)`;
        let reg = new RegExp(tpReg);
        let regG = new RegExp(tpReg, 'g');

        /** Nếu Hash đc */
        if (item.Key.match(reg)) {
          /** Hash element */
          let ele = item.Key.split(reg);
          /** Hash formula */
          let operas = [...item.Key.match(regG)].map(x => x[0]);
          /** Mặc định dấu đầu là dấu (+) */
          operas.length < ele.length && operas.unshift('+');

          /** Hash element and save to Stack */
          item.Key.split(reg).forEach((str, i) => {
            let oItem = {
              Key: str,
              Opera: i ? operas[i] : '+',
              Parent: item.Id,
              Grade: item.Grade + 1,
              Id: stack.length,
            };
            stack.push(oItem);
            func(oItem, opera.includes('+') ? multi : sum);
          });
        } else if (item.Key.match(/\+|\-|\*|\//)) {
          func(item, opera.includes('+') ? multi : sum);
        }
      };

      /** Hash phần tử đầu */
      func(stack[0], sum);

      /** Lấy các node lá và gán giá trị */
      let leafs = stack.filter(x => stack.every(o => o.Parent != x.Id));
      leafs.forEach(x => (x.Value = obj[x.Key] || 0));

      // /** Tính giá trị cho các node cha */
      let calculate = item => {
        let childs = stack.filter(c => c.Parent == item.Id);
        if (childs.length) {
          childs.forEach(calculate);

          item.Value = childs.reduce((val, x) => that.calculateOperation(val, x.Value, x.Opera), 0);
        }
      };

      calculate(stack[0]);

      /** Lấy giá trị */
      result = stack[0].Value;
    }

    return result;
  }

  /**
   * Tính toán lại dữ liệu cây
   * @param {Array} data Dữ liệu
   * @param {string} idField Trường ID
   * @param {string} parentField Trường Id cha
   * @param {Array} numberFields Danh sách trường cần cộng
   * @author nnnam - 25/4/2022
   */
  calculateTree(data, key, field, idField, parentField, formulaCol) {
    if (data.length) {
      var that = this;
      /** Mặc định công thức cột rỗng */
      formulaCol = formulaCol || {};

      /** Băm công thức cột */
      let formulaHashCol = Object.keys(formulaCol).reduce(
        (obj, key) => {
          /** @type string */
          let fomuCol = formulaCol[key].replaceAll(' ', '');
          /** Tách cột */
          let spl = fomuCol.split(/\+|\-|\*|\\/);
          /** Lưu lại các cột */
          obj.Hash[key] = spl;
          /** Lưu lại tất cả cột */
          obj.All = obj.All.concat(spl);
          return obj;
        },
        {Hash: {}, All: [field]},
      );

      /** Băm cột */
      let hashCol = formulaHashCol.Hash;
      /** Tất cả các cột */
      let allCols = this.distinct(formulaHashCol.All);
      /** Các cột root */
      let colRoots = Object.keys(hashCol).filter(col => allCols.every(x => col != x));

      /** Tìm các node cha */
      let findParents = function (obj, key, hash) {
        let parents = Object.keys(hash).filter(x => hash[x].some(o => o == key));
        obj.Item = that.distinct(obj.Item.concat(parents));
        parents.forEach(key => {
          obj.Child = obj.Child.concat(hash[key]);
          findParents(obj, key, hash);
        });

        obj.Child = that.distinct(obj.Child.filter(child => obj.Item.every(o => o != child)));
        return obj;
      };

      /** Các cột root */
      let rootColRs = findParents({Item: [], Child: [field]}, field, hashCol);
      /** Filter cột root */
      let rootCols = rootColRs.Item.filter(x => colRoots.some(o => o == x));
      let rows = [];

      /** Tính toán dòng */
      let calculateRow = node => {
        let parents = data.filter(x => x[idField] == node[parentField]);

        rows = [...rows, ...parents];

        parents.forEach(parent => {
          // Nếu trạng thái dòng cha là none thì cần gán lại state để cập nhật db
          if (parent.state == 0) {
            parent.state = 2;
          }
          let childs = data.filter(x => x[parentField] == parent[idField]);

          rootColRs.Child.forEach(field => {
            parent[field] = childs.reduce((sum, child) => sum + parseFloat(child[field] || 0), 0);
          });

          calculateRow(parent);
        });
      };

      /** Tính toán cột */
      let calculateCol = function (col) {
        let childs = hashCol[col];
        let items = childs.filter(x => rootColRs.Item.some(o => o == x));
        items.forEach(calculateCol);

        /** For từng dòng */
        rows.forEach(row => {
          let express = childs.reduce((o, x) => ({...o, [x]: row[x]}), {});
          row[col] = that.calculateByFormula(express, formulaCol[col]);
        });
      };

      /** Tính toán dòng */
      data.filter(x => x[idField] == key).forEach(node => calculateRow(node));
      /** Tính toán cột */
      rootCols.forEach(calculateCol);
    }
  }

  /**
   * Tính toán dữ liệu bằng công thức
   * @param {Array} data dữ liệu bảng
   * @param {any} keyField : DataField tính toán nằm trong formula
   * @param {any} key : VD: row[keyField]
   * @param {any} field : DataField đang sửa
   * @param {any} formulaCol : Công thức cột: {A: 'B + C'} (Cộng ngang)
   * @param {any} formulaField
   * @param {any} isGrid : Là grid
   * @author nnam - 23/5/2022
   */
  calculateByFormulaColumn(data, keyField, key, field, formulaCol, formulaField = 'formula', isGrid) {
    if (data) {
      /** Mặc định công thức cột rỗng */
      formulaCol = formulaCol || {};

      var that = this;

      /** Băm công thức cột */
      let formulaHashCol = Object.keys(formulaCol).reduce(
        (obj, key) => {
          /** @type string */
          let fomuCol = formulaCol[key].replaceAll(' ', '');
          /** Tách cột */
          let spl = fomuCol.split(/\+|\-|\*|\\/);
          /** Lưu lại các cột */
          obj.Hash[key] = spl;
          /** Lưu lại tất cả cột */
          obj.All = obj.All.concat(spl);
          return obj;
        },
        {Hash: {}, All: [field]},
      );

      /** Băm công thức dòng */
      let formulaHashRow = data
        .filter(x => x[formulaField])
        .reduce(
          (obj, item) => {
            let key = item[keyField];
            /** @type string */
            let formu = item[formulaField].replaceAll(' ', '');
            /** Tách công thức */
            let spl = formu.split(/\+|\-|\*|\\/);
            /** Lưu lại công thức */
            obj.Row[key] = formu;
            /** lưu cột */
            obj.Hash[key] = spl;
            /** Lưu tất cả cột */
            obj.All = obj.All.concat(spl);
            return obj;
          },
          {Row: {}, Hash: {}, All: [key]},
        );

      /** Băm cột */
      let hashCol = formulaHashCol.Hash;
      /** Băm dòng */
      let fomulaRow = formulaHashRow.Row;
      /** Các cột sau khi băm */
      let hashRow = formulaHashRow.Hash;
      /** Tất cả các key */
      let allKeys = that.distinct(formulaHashRow.All);
      /** Tất cả các cột */
      let allCols = that.distinct(formulaHashCol.All);
      /** Các key cha */
      let parentRoots = Object.keys(fomulaRow).filter(key => allKeys.every(x => x != key));
      /** Các cột root */
      let colRoots = Object.keys(hashCol).filter(col => allCols.every(x => col != x));

      /** Tìm các node cha */
      let findParents = function (obj, key, hash) {
        let parents = Object.keys(hash).filter(x => hash[x].some(o => o == key));
        obj.Item = that.distinct(obj.Item.concat(parents));
        parents.forEach(key => {
          obj.Child = obj.Child.concat(hash[key]);
          findParents(obj, key, hash);
        });

        obj.Child = that.distinct(obj.Child.filter(child => obj.Item.every(o => o != child)));
        return obj;
      };

      /** Các cột root */
      let rootColRs = findParents({Item: [], Child: [field]}, field, hashCol);
      /** Các dòng root */
      let rootRowRs = findParents({Item: [], Child: [key]}, key, hashRow);
      /** Filter cột root */
      let rootCols = rootColRs.Item.filter(x => colRoots.some(o => o == x));
      /** Filter dòng root */
      let rootRows = rootRowRs.Item.filter(x => parentRoots.some(o => o == x));
      /** Các dòng chứa công thức */
      let rows = rootRowRs.Child.concat(rootRowRs.Item).reduce(
        (obj, x) => ({...obj, [x]: data.filter(o => o[keyField] == x)}),
        {},
      );
      /** Lấy các dòng công thức tiêu biểu */
      let rowItems = Object.keys(rows).reduce((obj, key) => ({...obj, [key]: rows[key] && rows[key][0]}), {});

      /** Tính toán dòng */
      let calculateRow = function (key) {
        let childs = hashRow[key];
        let items = childs.filter(x => rootRowRs.Item.some(o => o == x));
        items.forEach(calculateRow);

        /** For từng cột */
        rootColRs.Child.forEach(col => {
          let express = childs.reduce((o, x) => {
            o[x] = rowItems[x][col];
            return o;
          }, {});
          let val = that.calculateByFormula(express, fomulaRow[key]);
          rows[key].forEach(item => {
            item[col] = val;
            if (isGrid) {
              // Xử lý state nếu empty => Insert, nếu None thì gán về Update
              if (item.state === 4) {
                item.state = 1;
              } else if (item.state === 0) {
                item.state = 2;
              }
            }
          });
        });
      };

      /** Tính toán cột */
      let calculateCol = function (col) {
        let childs = hashCol[col];
        let items = childs.filter(x => rootColRs.Item.some(o => o == x));
        items.forEach(calculateCol);

        /** For từng dòng */
        Object.keys(rowItems).forEach(key => {
          let express = childs.reduce((o, x) => ({...o, [x]: rowItems[key][x]}), {});
          let val = that.calculateByFormula(express, formulaCol[col]);
          rows[key].forEach(item => (item[col] = val));
        });
      };

      /** Tính toán dòng */
      rootRows.forEach(calculateRow);
      /** Tính toán cột */
      rootCols.forEach(calculateCol);
    }
  }

  /**
   * Tính toán lại dữ liệu bằng công thức
   * @param {Array} data
   * @param {any} keyField
   * @param {any} formulaCol
   * @param {Array} cols Các cột cần tình mà không có trong công thức
   * @param {any} formulaField
   * @author nnam - 23/5/2022
   */
  refreshByFormulaColumn(data, keyField, formulaCol, cols, formulaField = 'Formula') {
    if (data) {
      let that = this;
      /** Mặc định công thức cột rỗng */
      formulaCol = formulaCol || {};
      cols = cols || [];

      /** Băm công thức cột */
      let formulaHashCol = Object.keys(formulaCol).reduce(
        (obj, key) => {
          /** @type string */
          let fomuCol = formulaCol[key].replaceAll(' ', '');
          /** Tách cột */
          let spl = fomuCol.split(/\+|\-|\*|\\/);
          /** Lưu lại các cột */
          obj.Hash[key] = spl;
          /** Lưu lại tất cả cột */
          obj.All = obj.All.concat(spl);
          return obj;
        },
        {Hash: {}, All: []},
      );

      /** Băm công thức dòng */
      let formulaHashRow = data
        .filter(x => x[formulaField])
        .reduce(
          (obj, item) => {
            let key = item[keyField];
            /** @type string */
            let formu = item[formulaField].replaceAll(' ', '');
            /** Tách công thức */
            let spl = formu.split(/\+|\-|\*|\\/);
            /** Lưu lại công thức */
            obj.Row[key] = formu;
            /** lưu cột */
            obj.Hash[key] = spl;
            /** Lưu tất cả cột */
            obj.All = obj.All.concat(spl);
            return obj;
          },
          {Row: {}, Hash: {}, All: []},
        );

      /** Băm cột */
      let hashCol = formulaHashCol.Hash;
      /** Băm dòng */
      let fomulaRow = formulaHashRow.Row;
      /** Các cột sau khi băm */
      let hashRow = formulaHashRow.Hash;
      /** Tất cả các key */
      let allKeys = this.distinct(formulaHashRow.All);
      /** Tất cả các cột */
      let allCols = this.distinct(formulaHashCol.All);
      /** Các key cha */
      let rootRows = Object.keys(fomulaRow).filter(key => allKeys.every(x => x != key));
      /** Các cột root */
      let rootCols = Object.keys(hashCol).filter(col => allCols.every(x => col != x));
      //NVTUAN1 01.03.2024: Sử dụng hàm hasOwnProperty không ảnh hưởng bởi PBI 419812
      let childCols = allCols.concat(cols).filter(x => !formulaCol.hasOwnProperty(x));

      /** Các dòng chứa công thức */
      let rows = this.distinct(allKeys.concat(rootRows)).reduce(
        (obj, x) => ({...obj, [x]: data.filter(o => o[keyField] == x)}),
        {},
      );
      /** Lấy các dòng công thức tiêu biểu */
      let rowItems = Object.keys(rows).reduce((obj, key) => ({...obj, [key]: rows[key] && rows[key][0]}), {});

      /** Tính toán dòng */
      let calculateRow = function (key) {
        let childs = hashRow[key];

        if (childs) {
          childs.forEach(calculateRow);

          /** For từng cột */
          childCols.forEach(col => {
            let express = childs.reduce((o, x) => ({...o, [x]: rowItems[x][col]}), {});
            let val = that.calculateByFormula(express, fomulaRow[key]);
            rows[key].forEach(item => (item[col] = val));
          });
        }
      };

      /** Tính toán cột */
      let calculateCol = function (col) {
        let childs = hashCol[col];
        if (childs) {
          childs.forEach(calculateCol);

          /** For từng dòng */
          Object.keys(rowItems).forEach(key => {
            let express = childs.reduce((o, x) => ({...o, [x]: rowItems[key][x]}), {});
            let val = that.calculateByFormula(express, formulaCol[col]);
            rows[key].forEach(item => (item[col] = val));
          });
        }
      };

      /** Tính toán dòng */
      rootRows.forEach(calculateRow);
      /** Tính toán cột */
      rootCols.forEach(calculateCol);
    }
  }

  /**
   * Hàm chuẩn hóa tham số
   */
  nomalizeLoadParameter(payload) {
    if (!payload.skip) {
      delete payload.skip;
    }

    if (payload.filter && payload.filter.length > 0) {
      //Clear múi giờ trước khi đẩy lên server
      payload.filter.forEach((item, i) => {
        let value = item.value;
        if (value) {
          if (typeof value.getFullYear === 'function') {
            item.value = this.getMoment(value).format('YYYY-MM-DDTHH:mm:ss');
          }
        }
      });

      payload.filter = JSON.stringify(payload.filter);
    } else {
      delete payload.filter;
    }

    if (payload.condition && Object.keys(payload.condition).length > 0) {
      payload.condition = JSON.stringify(payload.condition);
    } else {
      delete payload.condition;
    }

    if (payload.columns && payload.columns.length > 0) {
      payload.columns = payload.columns.join(',');
    } else {
      delete payload.columns;
    }
  }

  /**
   * Set từ ngày đến ngày theo kì báo cáo
   * @author nnnam - 20/7/2022
   */
  getDateRange(period, data, flag, type) {
    /**
     * Lấy dữ liệu ngày hiện tại theo ngày HT
     * NXCHIEN 26.07.2022
     */
    let getPostedDate = flag => {
      if (flag && flag.isCheck) {
        return new Date(moment(flag.value).format('YYYY-MM-DD'));
      }
      return new Date();
    };

    let dateRange = {};
    if (typeof period !== 'undefined') {
      //Lấy thông tin tuần
      let dateWeek = getPostedDate(flag);

      let day = dateWeek.getDay() === 0 ? 7 : dateWeek.getDay(); // NXCHIEN tính lại ngày đầu tuần
      let first = dateWeek.getDate() - day + 1;
      let last = first + 6;
      let firstWeek = new Date(getPostedDate(flag).setDate(first));
      let lastWeek = new Date(getPostedDate(flag).setDate(last));

      //Lấy thông tin tháng
      let dateMonth = getPostedDate(flag);
      let firstMonth = new Date(dateMonth.getFullYear(), dateMonth.getMonth(), 1);

      let lastMonth = new Date(dateMonth.getFullYear(), dateMonth.getMonth() + 1, 0);

      let startCurrentQuater = moment(getPostedDate(flag))
        .quarter(moment(getPostedDate(flag)).quarter())
        .startOf('quarter');

      let endCurrentQuater = moment(getPostedDate(flag))
        .quarter(moment(getPostedDate(flag)).quarter())
        .endOf('quarter');

      if (!type || type == 'Period' || type == 'ReportPeriodCustom' || type == 'PeriodDashboard') {
        switch (period) {
          case MSConstant.Period.ThisDay:
            dateRange.fromDate = moment(dateWeek).format('YYYY-MM-DD');
            dateRange.toDate = moment(dateWeek).format('YYYY-MM-DD');
            break;

          case MSConstant.Period.ThisWeek:
            dateRange.fromDate = moment(firstWeek).format('YYYY-MM-DD');
            dateRange.toDate = moment(lastWeek).format('YYYY-MM-DD');
            break;

          case MSConstant.Period.FirstWeekToPresent:
            dateRange.fromDate = moment(firstWeek).format('YYYY-MM-DD');
            dateRange.toDate = moment(dateWeek).format('YYYY-MM-DD');
            break;

          case MSConstant.Period.ThisMonth:
            dateRange.fromDate = moment(firstMonth).format('YYYY-MM-DD');
            dateRange.toDate = moment(lastMonth).format('YYYY-MM-DD');
            break;

          case MSConstant.Period.FirstMonthToPresent:
            dateRange.fromDate = moment(firstMonth).format('YYYY-MM-DD');
            dateRange.toDate = moment(dateWeek).format('YYYY-MM-DD');
            break;

          case MSConstant.Period.ThisQuarter:
            dateRange.fromDate = startCurrentQuater.format('YYYY-MM-DD');
            dateRange.toDate = endCurrentQuater.format('YYYY-MM-DD');
            break;

          case MSConstant.Period.FirstQuarterToPresent:
            dateRange.fromDate = startCurrentQuater.format('YYYY-MM-DD');
            dateRange.toDate = moment(dateWeek).format('YYYY-MM-DD');
            break;

          case MSConstant.Period.ThisYear:
            dateRange.fromDate = moment(new Date(dateWeek.getFullYear(), 0, 1)).format('YYYY-MM-DD');
            dateRange.toDate = moment(new Date(dateWeek.getFullYear(), 11, 31)).format('YYYY-MM-DD');
            break;

          case MSConstant.Period.FirstYearToPresent:
            dateRange.fromDate = moment(new Date(dateWeek.getFullYear(), 0, 1)).format('YYYY-MM-DD');
            dateRange.toDate = moment(dateWeek).format('YYYY-MM-DD');
            break;

          case MSConstant.Period.SixFirstMonth:
            dateRange.fromDate = moment(new Date(dateWeek.getFullYear(), 0, 1)).format('YYYY-MM-DD');
            dateRange.toDate = moment(new Date(dateWeek.getFullYear(), 6, 0)).format('YYYY-MM-DD');
            break;

          case MSConstant.Period.SixLastMonth:
            dateRange.fromDate = moment(new Date(dateWeek.getFullYear(), 6, 1)).format('YYYY-MM-DD');
            dateRange.toDate = moment(new Date(dateWeek.getFullYear(), 11, 31)).format('YYYY-MM-DD');
            break;

          case MSConstant.Period.January:
            dateRange.fromDate = moment(new Date(dateWeek.getFullYear(), 0, 1)).format('YYYY-MM-DD');
            dateRange.toDate = moment(new Date(dateWeek.getFullYear(), 1, 0)).format('YYYY-MM-DD');
            break;

          case MSConstant.Period.February:
            dateRange.fromDate = moment(new Date(dateWeek.getFullYear(), 1, 1)).format('YYYY-MM-DD');
            dateRange.toDate = moment(new Date(dateWeek.getFullYear(), 2, 0)).format('YYYY-MM-DD');
            break;

          case MSConstant.Period.March:
            dateRange.fromDate = moment(new Date(dateWeek.getFullYear(), 2, 1)).format('YYYY-MM-DD');
            dateRange.toDate = moment(new Date(dateWeek.getFullYear(), 3, 0)).format('YYYY-MM-DD');
            break;

          case MSConstant.Period.April:
            dateRange.fromDate = moment(new Date(dateWeek.getFullYear(), 3, 1)).format('YYYY-MM-DD');
            dateRange.toDate = moment(new Date(dateWeek.getFullYear(), 4, 0)).format('YYYY-MM-DD');
            break;

          case MSConstant.Period.May:
            dateRange.fromDate = moment(new Date(dateWeek.getFullYear(), 4, 1)).format('YYYY-MM-DD');
            dateRange.toDate = moment(new Date(dateWeek.getFullYear(), 5, 0)).format('YYYY-MM-DD');
            break;

          case MSConstant.Period.June:
            dateRange.fromDate = moment(new Date(dateWeek.getFullYear(), 5, 1)).format('YYYY-MM-DD');
            dateRange.toDate = moment(new Date(dateWeek.getFullYear(), 6, 0)).format('YYYY-MM-DD');
            break;

          case MSConstant.Period.July:
            dateRange.fromDate = moment(new Date(dateWeek.getFullYear(), 6, 1)).format('YYYY-MM-DD');
            dateRange.toDate = moment(new Date(dateWeek.getFullYear(), 7, 0)).format('YYYY-MM-DD');
            break;

          case MSConstant.Period.August:
            dateRange.fromDate = moment(new Date(dateWeek.getFullYear(), 7, 1)).format('YYYY-MM-DD');
            dateRange.toDate = moment(new Date(dateWeek.getFullYear(), 8, 0)).format('YYYY-MM-DD');
            break;

          case MSConstant.Period.September:
            dateRange.fromDate = moment(new Date(dateWeek.getFullYear(), 8, 1)).format('YYYY-MM-DD');
            dateRange.toDate = moment(new Date(dateWeek.getFullYear(), 9, 0)).format('YYYY-MM-DD');
            break;

          case MSConstant.Period.October:
            dateRange.fromDate = moment(new Date(dateWeek.getFullYear(), 9, 1)).format('YYYY-MM-DD');
            dateRange.toDate = moment(new Date(dateWeek.getFullYear(), 10, 0)).format('YYYY-MM-DD');
            break;

          case MSConstant.Period.November:
            dateRange.fromDate = moment(new Date(dateWeek.getFullYear(), 10, 1)).format('YYYY-MM-DD');
            dateRange.toDate = moment(new Date(dateWeek.getFullYear(), 11, 0)).format('YYYY-MM-DD');
            break;

          case MSConstant.Period.December:
            dateRange.fromDate = moment(new Date(dateWeek.getFullYear(), 11, 1)).format('YYYY-MM-DD');
            dateRange.toDate = moment(new Date(dateWeek.getFullYear(), 11, 31)).format('YYYY-MM-DD');
            break;

          case MSConstant.Period.FiscalI:
            dateRange.fromDate = moment(dateWeek).quarter(1).startOf('quarter').format('YYYY-MM-DD');
            dateRange.toDate = moment(dateWeek).quarter(1).endOf('quarter').format('YYYY-MM-DD');
            break;

          case MSConstant.Period.FiscalII:
            dateRange.fromDate = moment(dateWeek).quarter(2).startOf('quarter').format('YYYY-MM-DD');
            dateRange.toDate = moment(dateWeek).quarter(2).endOf('quarter').format('YYYY-MM-DD');
            break;

          case MSConstant.Period.FiscalIII:
            dateRange.fromDate = moment(dateWeek).quarter(3).startOf('quarter').format('YYYY-MM-DD');
            dateRange.toDate = moment(dateWeek).quarter(3).endOf('quarter').format('YYYY-MM-DD');
            break;

          case MSConstant.Period.FiscalIV:
            dateRange.fromDate = moment(dateWeek).quarter(4).startOf('quarter').format('YYYY-MM-DD');
            dateRange.toDate = moment(dateWeek).quarter(4).endOf('quarter').format('YYYY-MM-DD');
            break;

          case MSConstant.Period.Yesterday:
            dateRange.fromDate = moment(dateWeek).subtract(1, 'days').startOf('day').format('YYYY-MM-DD');
            dateRange.toDate = moment(dateWeek).subtract(1, 'days').endOf('day').format('YYYY-MM-DD');
            break;

          case MSConstant.Period.LastWeek:
            dateRange.fromDate = moment(dateWeek).subtract(1, 'weeks').startOf('week').format('YYYY-MM-DD');
            dateRange.toDate = moment(dateWeek).subtract(1, 'weeks').endOf('week').format('YYYY-MM-DD');
            break;

          case MSConstant.Period.LastMonth:
            dateRange.fromDate = moment(dateWeek).subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
            dateRange.toDate = moment(dateWeek).subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
            break;

          case MSConstant.Period.LastQuarter:
            dateRange.fromDate = moment(dateWeek)
              .quarter(moment(dateWeek).quarter())
              .subtract(1, 'Q')
              .startOf('quarter')
              .format('YYYY-MM-DD');
            dateRange.toDate = moment(dateWeek)
              .quarter(moment(dateWeek).quarter())
              .subtract(1, 'Q')
              .endOf('quarter')
              .format('YYYY-MM-DD');
            break;

          case MSConstant.Period.LastYear:
            dateRange.fromDate = moment(dateWeek).subtract(1, 'years').startOf('year').format('YYYY-MM-DD');
            dateRange.toDate = moment(dateWeek).subtract(1, 'years').endOf('year').format('YYYY-MM-DD');
            break;

          case MSConstant.Period.Tomorrow:
            dateRange.fromDate = moment(dateWeek).subtract(-1, 'days').startOf('day').format('YYYY-MM-DD');
            dateRange.toDate = moment(dateWeek).subtract(-1, 'days').endOf('day').format('YYYY-MM-DD');
            break;

          case MSConstant.Period.NextWeek:
            dateRange.fromDate = moment(dateWeek).subtract(-1, 'weeks').startOf('week').format('YYYY-MM-DD');
            dateRange.toDate = moment(dateWeek).subtract(-1, 'weeks').endOf('week').format('YYYY-MM-DD');
            break;

          case MSConstant.Period.NextMonth:
            dateRange.fromDate = moment(dateWeek).subtract(-1, 'months').startOf('month').format('YYYY-MM-DD');
            dateRange.toDate = moment(dateWeek).subtract(-1, 'months').endOf('month').format('YYYY-MM-DD');
            break;

          case MSConstant.Period.NextQuarter:
            dateRange.fromDate = moment(dateWeek)
              .quarter(moment(dateWeek).quarter())
              .subtract(-1, 'Q')
              .startOf('quarter')
              .format('YYYY-MM-DD');
            dateRange.toDate = moment(dateWeek)
              .quarter(moment(dateWeek).quarter())
              .subtract(-1, 'Q')
              .endOf('quarter')
              .format('YYYY-MM-DD');
            break;

          case MSConstant.Period.NextYear:
            dateRange.fromDate = moment(dateWeek).subtract(-1, 'years').startOf('year').format('YYYY-MM-DD');
            dateRange.toDate = moment(dateWeek).subtract(-1, 'years').endOf('year').format('YYYY-MM-DD');
            break;
          case MSConstant.ReportPeriodCustom.Next4Week:
            dateRange.fromDate = moment(dateWeek).subtract(-1, 'weeks').startOf('week').format('YYYY-MM-DD');
            dateRange.toDate = moment(dateWeek).subtract(-4, 'weeks').endOf('week').format('YYYY-MM-DD');
            break;
          case MSConstant.Period.Custom:
            dateRange.fromDate = data?.fromDate;
            dateRange.toDate = data?.toDate;
            break;

          default:
            dateRange.fromDate = null;
            dateRange.toDate = null;
            break;
        }
      } else {
        let year = getPostedDate(flag).getFullYear();
        let month = getPostedDate(flag).getMonth();
        let curMonthQ = month - (month % 3);

        let arr = [
          {
            from: month,
            to: month + 1,
            val: MSConstant.ReportPeriod.ThisMonth,
          },
          /** Tháng */
          {from: 0, to: 1, val: MSConstant.ReportPeriod.January},
          {from: 1, to: 2, val: MSConstant.ReportPeriod.February},
          {from: 2, to: 3, val: MSConstant.ReportPeriod.March},
          {from: 3, to: 4, val: MSConstant.ReportPeriod.April},
          {from: 4, to: 5, val: MSConstant.ReportPeriod.May},
          {from: 5, to: 6, val: MSConstant.ReportPeriod.June},
          {from: 6, to: 7, val: MSConstant.ReportPeriod.July},
          {from: 7, to: 8, val: MSConstant.ReportPeriod.August},
          {from: 8, to: 9, val: MSConstant.ReportPeriod.September},
          {from: 9, to: 10, val: MSConstant.ReportPeriod.October},
          {from: 10, to: 11, val: MSConstant.ReportPeriod.November},
          {from: 11, to: 12, val: MSConstant.ReportPeriod.December},

          {
            from: curMonthQ,
            to: curMonthQ + 3,
            val: MSConstant.ReportPeriod.ThisQuarter,
          },

          /** Quý */
          {from: 0, to: 3, val: MSConstant.ReportPeriod.QuarterI},
          {from: 3, to: 6, val: MSConstant.ReportPeriod.QuarterII},
          {from: 6, to: 9, val: MSConstant.ReportPeriod.QuarterIII},
          {from: 9, to: 12, val: MSConstant.ReportPeriod.QuarterIV},
          /** 6 tháng */
          {from: 0, to: 6, val: MSConstant.ReportPeriod.FirtsHalfYear},
          {from: 6, to: 12, val: MSConstant.ReportPeriod.SecondHalfYear},
          /** Năm */
          {from: 0, to: 12, val: MSConstant.ReportPeriod.Year},
        ];

        var item = arr.find(x => x.val == period);

        let getDay = day => moment(day).format('YYYY-MM-DD');

        if (item) {
          dateRange.fromDate = getDay(new Date(year, item.from, 1));
          dateRange.toDate = getDay(new Date(year, item.to, 0));
        } else {
          dateRange.fromDate = data?.fromDate;
          dateRange.toDate = data?.toDate;
        }
      }
    }
    dateRange.periodText = this.getEnumResource(period || MSConstant.Period.Custom, type || 'Period');

    return dateRange;
  }

  /**
   * Lấy kỳ theo Ngày bắt đầu, Ngày kết thúc
   * @author nnnam - 22/7/2022
   */
  getPeriodByDate(fromDate, toDate, flag, type, current) {
    let period = MSConstant.Period.Custom;
    let isReport = type == 'ReportPeriod';
    /**
     * Lấy dữ liệu ngày hiện tại theo ngày HT
     * NXCHIEN 26.07.2022
     */
    let getPostedDate = flag => {
      if (flag && flag.isCheck) {
        return new Date(moment(flag.value).format('YYYY-MM-DD'));
      }
      return new Date();
    };

    if (fromDate && toDate) {
      fromDate = new Date(fromDate).getDateOnly();
      toDate = new Date(toDate).getDateOnly();

      let curDte = getPostedDate(flag);

      let fromDay = fromDate.getDate();
      let fromMonth = fromDate.getMonth() + 1;
      let fromYear = fromDate.getFullYear();

      let nextToDate = new Date(toDate).addDays(1);
      let nextToDay = nextToDate.getDate();
      let nextToMonth = nextToDate.getMonth() + 1;
      let nextToYear = nextToDate.getFullYear();

      let year = curDte.getFullYear();
      let month = curDte.getMonth() + 1;
      let curMonthQ = month - ((month - 1) % 3) - 1;

      let startCurrentQuater = moment(curDte).quarter(moment(curDte).quarter()).startOf('quarter');

      let endCurrentQuater = moment(curDte).quarter(moment(curDte).quarter()).endOf('quarter');

      let item;

      /** Giá trị map các tháng và giá trị */
      let months = [
        /** Tháng này */
        {
          from: month,
          to: month + 1,
          val: MSConstant.Period.ThisMonth,
          report: MSConstant.ReportPeriod.ThisMonth,
        },
        {
          from: month - 1 || 12,
          to: month,
          val: MSConstant.Period.LastMonth,
          year: month - 1 ? year : year - 1,
        },
        {
          from: month + 1,
          to: month + 2,
          val: MSConstant.Period.NextMonth,
          year: month + 1 < 13 ? year : year + 1,
        },
        {
          from: month,
          to: month + 1,
          val: MSConstant.Period.FirstMonthToPresent,
        },
        /** Tháng */
        {
          from: 1,
          to: 2,
          val: MSConstant.Period.January,
          report: MSConstant.ReportPeriod.January,
        },
        {
          from: 2,
          to: 3,
          val: MSConstant.Period.February,
          report: MSConstant.ReportPeriod.February,
        },
        {
          from: 3,
          to: 4,
          val: MSConstant.Period.March,
          report: MSConstant.ReportPeriod.March,
        },
        {
          from: 4,
          to: 5,
          val: MSConstant.Period.April,
          report: MSConstant.ReportPeriod.April,
        },
        {
          from: 5,
          to: 6,
          val: MSConstant.Period.May,
          report: MSConstant.ReportPeriod.May,
        },
        {
          from: 6,
          to: 7,
          val: MSConstant.Period.June,
          report: MSConstant.ReportPeriod.June,
        },
        {
          from: 7,
          to: 8,
          val: MSConstant.Period.July,
          report: MSConstant.ReportPeriod.July,
        },
        {
          from: 8,
          to: 9,
          val: MSConstant.Period.August,
          report: MSConstant.ReportPeriod.August,
        },
        {
          from: 9,
          to: 10,
          val: MSConstant.Period.September,
          report: MSConstant.ReportPeriod.September,
        },
        {
          from: 10,
          to: 11,
          val: MSConstant.Period.October,
          report: MSConstant.ReportPeriod.October,
        },
        {
          from: 11,
          to: 12,
          val: MSConstant.Period.November,
          report: MSConstant.ReportPeriod.November,
        },
        {
          from: 12,
          to: 13,
          val: MSConstant.Period.December,
          report: MSConstant.ReportPeriod.December,
        },
        /** Quý này */
        {
          from: curMonthQ + 1,
          to: curMonthQ + 4,
          val: MSConstant.Period.ThisQuarter,
          report: MSConstant.ReportPeriod.ThisQuarter,
        },
        {
          from: curMonthQ - 2,
          to: curMonthQ + 1,
          val: MSConstant.Period.LastQuarter,
        },
        {
          from: curMonthQ + 4,
          to: curMonthQ + 7,
          val: MSConstant.Period.NextQuarter,
        },
        /** Quý */
        {
          from: 1,
          to: 4,
          val: MSConstant.Period.FiscalI,
          report: MSConstant.ReportPeriod.QuarterI,
        },
        {
          from: 4,
          to: 7,
          val: MSConstant.Period.FiscalII,
          report: MSConstant.ReportPeriod.QuarterII,
        },
        {
          from: 7,
          to: 10,
          val: MSConstant.Period.FiscalIII,
          report: MSConstant.ReportPeriod.QuarterIII,
        },
        {
          from: 10,
          to: 13,
          val: MSConstant.Period.FiscalIV,
          report: MSConstant.ReportPeriod.QuarterIV,
        },
        /** 6 tháng */
        {
          from: 1,
          to: 7,
          val: MSConstant.Period.SixFirstMonth,
          report: MSConstant.ReportPeriod.FirtsHalfYear,
        },
        {
          from: 7,
          to: 13,
          val: MSConstant.Period.SixLastMonth,
          report: MSConstant.ReportPeriod.SecondHalfYear,
        },
        /** Năm */
        {
          from: 1,
          to: 13,
          val: MSConstant.Period.ThisYear,
          report: MSConstant.ReportPeriod.Year,
        },
        {from: 1, to: 13, val: MSConstant.Period.LastYear, year: year - 1},
        {from: 1, to: 13, val: MSConstant.Period.NextYear, year: year + 1},
      ];

      /** Nếu tròn tháng */
      if (
        fromDay == 1 &&
        nextToDay == 1 &&
        (current != MSConstant.Period.FirstYearToPresent ||
          this.compareDate(curDte, toDate) ||
          fromMonth != 1 ||
          fromYear != year)
      ) {
        var items = months.filter(
          x =>
            x.from == fromMonth && x.to == nextToMonth + (nextToYear - fromYear) * 12 && fromYear == (x.year || year),
        );
        if (isReport) {
          items = items.filter(x => x.report);
          item = items.find(x => x.report == current) || items[0];
          period = item?.report;
        } else {
          if (items?.length > 0) {
            item = items[0] || items.find(x => x.val == current);
            period = item?.val;
          } else {
            item = items.find(x => x.val == current) || items[0];
            period = item?.val;
          }
        }
      } else if (!isReport) {
        //Lấy thông tin tuần
        let now = getPostedDate(flag).getDateOnly();
        let day = now.getDay() === 0 ? 7 : now.getDay(); // NXCHIEN tính lại ngày đầu tuần
        let first = now.getDate() - day + 1;

        let firstWeek = new Date(new Date(now).setDate(first));
        let lastWeek = new Date(new Date(now).setDate(first + 6));

        /** Case theo ngày */
        var arr = [
          {from: now, to: now, val: MSConstant.Period.ThisDay},
          {
            from: new Date(now).addDays(-1),
            to: new Date(now).addDays(-1),
            val: MSConstant.Period.Yesterday,
          },
          {
            from: new Date(now).addDays(1),
            to: new Date(now).addDays(1),
            val: MSConstant.Period.Tomorrow,
          },
          {
            from: new Date(firstWeek).addDays(-7),
            to: new Date(lastWeek).addDays(-7),
            val: MSConstant.Period.LastWeek,
          },
          {
            from: new Date(firstWeek).addDays(7),
            to: new Date(lastWeek).addDays(7),
            val: MSConstant.Period.NextWeek,
          },
          {from: firstWeek, to: lastWeek, val: MSConstant.Period.ThisWeek},
          {
            from: firstWeek,
            to: now,
            val: MSConstant.Period.FirstWeekToPresent,
          },
          {
            from: new Date(year, month - 1, 1),
            to: now,
            val: MSConstant.Period.FirstMonthToPresent,
          },
          {
            from: new Date(year, 0, 1),
            to: now,
            val: MSConstant.Period.FirstYearToPresent,
          },
          {
            from: startCurrentQuater.format('YYYY-MM-DD'),
            to: moment(curDte).format('YYYY-MM-DD'),
            val: MSConstant.Period.FirstQuarterToPresent,
          },
          {
            from: new Date(firstWeek).addDays(7),
            to: new Date(lastWeek).addDays(28),
            val: MSConstant.ReportPeriodCustom.Next4Week,
          },
        ];
        var items = arr.filter(x => moment(x.from).isSame(fromDate) && moment(x.to).isSame(toDate));

        item = items.find(x => x.val == current) || items[0];
        item && (period = item.val);
      }
    }

    period = period || (isReport ? MSConstant.ReportPeriod.Custom : period) || MSConstant.ReportPeriod.Custom;
    if (type == 'PeriodDashboard' && Object.values(MSConstant.PeriodDashboard).every(x => x != period)) {
      period = MSConstant.PeriodDashboard.Custom;
    }
    let periodText = this.getEnumResource(period, type || 'Period');
    return {period, periodText};
  }

  /**
   * Kiểm tra dữ liệu có phải dạng JSON hay ko
   * HQMINH 25.07.2022
   */
  isJson(str) {
    let bValue = true;
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return bValue;
  }

  /** Sắp xếp data theo tree
   * @author nnnam - 2/11/2020
   * @param {Array} data Dữ liệu sắp xếp
   * @param {string} fieldID Trường sắp xếp, key
   * @param {string} parentID ID của parent
   */
  sortTreeData(data, fieldID = 'id', parentID = 'ParentID') {
    /** Mảng kết quả sau khi sắp xếp theo tree */
    let sort = [];
    data = data.distinctkey(fieldID);
    /** Những node root grade 1 */
    let roots = data.filter(x => !x[parentID]);

    /**
     * Quy nạp Tìm node con => Thêm vào mảng kết quả
     * @author nnnam - 2/11/2020
     * @param {any} node Node cha
     */
    let initGroup = function (node) {
      /** Danh sách node con */
      let childs = data.filter(x => node[fieldID] && x[parentID] == node[fieldID]);
      /** Có phải là cha hay không? */
      node._isParent = !!childs.length;
      sort.push(node);
      childs.forEach(child => {
        child._grade = node._grade + 1;
        initGroup(child);
      });
    };

    roots.forEach(item => {
      item._grade = 1;
      initGroup(item);
    });

    return sort;
  }

  /**
   * Tìm những node cha trên tree
   * @author: nnnam - 3/11/2020
   * @param {any} data Dữ liệu tree
   * @param {any} node Node hiện tại
   * @param {any} fieldID Trường ID key để xác định node
   * @param {any} parentID ID node cha
   * @param {any} hasCurrent Có lấy đơn vị hiện tại không?
   */
  findParentNode(data, node, fieldID = 'id', parentID = 'ParentID', hasCurrent) {
    /** Mảng kết quả trả về chứa danh sách node cha */
    let parents = [];

    /**
     * Đệ quy tìm node cha của node hiện tại
     * @param {any} item Node hiện tại
     * @param {boolean} isCurrent Có Thêm node hiện tại ko?
     */
    let findParent = function (item, isCurrent) {
      /** Node cha */
      let parent = data.find(
        x =>
          x[fieldID] &&
          (x[fieldID] && x[fieldID].toLocaleLowerCase()) == (item[parentID] && item[parentID].toLocaleLowerCase()),
      );
      /** Nếu có node cha thì đệ quy tìm các node cao hơn */
      parent && findParent(parent);
      /** Nếu không có node hiện tại thì không Thêm */
      !isCurrent && parents.push(item);
    };

    findParent(node, !hasCurrent);
    return parents;
  }

  /**
   * Tìm những node cha trên tree
   * @author: nnnam - 3/11/2020
   * @param {any} data Dữ liệu tree
   * @param {any} id Node hiện tại
   * @param {any} fieldID Trường ID key để xác định node
   * @param {any} parentID ID node cha
   * @param {any} hasCurrent Có lấy đơn vị hiện tại không?
   */
  findParentsById(data, id, fieldID = 'id', parentID = 'ParentID', hasCurrent) {
    let node = data.find(x => x[fieldID] == id);
    return this.findParentNode(data, node, fieldID, parentID, hasCurrent);
  }

  /**
   * Tìm những node con trên tree
   * @author nnnam - 3/11/2020
   * @param {any} data Dữ liệu tree
   * @param {any} node Node hiện tại
   * @param {any} fieldID Trường ID key để xác định node
   * @param {any} parentID ID node cha
   * @param {any} hasCurrent Có lấy đơn vị hiện tại không?
   */
  findChildNode(data, node, fieldID, parentID, hasCurrent) {
    /** Mảng kết quả trả về chứa danh sách node con */
    let childs = [];
    fieldID = fieldID || 'id';
    parentID = parentID || 'ParentID';

    /**
     * Đệ quy tìm node con của node hiện tại
     * @param {any} item Node hiện tại
     * @param {boolean} isCurrent Có Thêm node hiện tại ko?
     */
    let findChilds = function (item, isCurrent) {
      /** Node con */
      let childArr = data.filter(
        x =>
          x[fieldID] &&
          (x[parentID] && x[parentID].toLocaleLowerCase()) == (item[fieldID] && item[fieldID].toLocaleLowerCase()),
      );
      /** Nếu không có node hiện tại thì không Thêm */
      !isCurrent && childs.push(item);
      /** Nếu có node con thì đệ quy tìm các node thấp hơn */
      childArr.forEach(child => findChilds(child));
    };

    findChilds(node, !hasCurrent);
    return childs;
  }

  /**
   * Tìm những node con trên tree
   * @author nnnam - 3/11/2020
   * @param {any} data Dữ liệu tree
   * @param {any} node Node hiện tại
   * @param {any} fieldID Trường ID key để xác định node
   * @param {any} parentID ID node cha
   * @param {any} hasCurrent Có lấy đơn vị hiện tại không?
   */
  findChildsById(data, id, fieldID, parentID, hasCurrent) {
    let node = data.find(x => x[fieldID] == id);
    return this.findChildNode(data, node, fieldID, parentID, hasCurrent);
  }

  /**
   * Tìm những node con trên tree
   * @author nnnam - 3/11/2020
   * @param {any} data Dữ liệu tree
   * @param {any} node Node hiện tại
   * @param {any} fieldID Trường ID key để xác định node
   * @param {any} parentID ID node cha
   * @param {any} hasCurrent Có lấy đơn vị hiện tại không?
   */
  findChildsByField(data, id, fieldID, childField, hasCurrent) {
    let node = data.find(x => x[fieldID] == id);
    let childs = [];
    fieldID = fieldID || 'id';
    childField = childField || 'childNodes';

    /**
     * Đệ quy tìm node con của node hiện tại
     * @param {any} item Node hiện tại
     * @param {boolean} isCurrent Có Thêm node hiện tại ko?
     */
    let findChilds = function (item, isCurrent) {
      /** Node con */
      let childArr = item[childField] || [];
      /** Nếu không có node hiện tại thì không Thêm */
      !isCurrent && childs.push(item);
      /** Nếu có node con thì đệ quy tìm các node thấp hơn */
      childArr.forEach(child => findChilds(child));
    };

    node && findChilds(node, !hasCurrent);
    return childs;
  }

  /**
   * Tìm những node con chi tiết nhất (node lá) trên tree
   * @author nnnam - 13/11/2020
   * @param {Array} data Dữ liệu tree
   * @param {object} node Node hiện tại
   * @param {string} fieldID Trường ID key để xác định node
   * @param {string} parentID ID node cha
   * @param {boolean} hasCurrent Có lấy đơn vị hiện tại không?
   */
  findLeafNodes(data, node, fieldID, parentID, hasCurrent) {
    /** Mảng kết quả trả về chứa danh sách node con */
    let childs = MISAUtil.findChildNode(data, node, fieldID, parentID, hasCurrent);
    let result = childs.filter(o => {
      /** Lấy những node con */
      //NVTUAN1 01.03.2024: Sử dụng hàm hasOwnProperty không ảnh hưởng bởi PBI 419812
      if (o.hasOwnProperty('_isParent')) {
        return !o._isParent;
      } else {
        return !childs.some(x => x[parentID] == o[fieldID]);
      }
    });

    return result;
  }

  /**
   * Tìm những node con trên tree
   * @author nnnam - 3/11/2020
   * @param {any} data Dữ liệu tree
   * @param {any} node Node hiện tại
   * @param {any} fieldID Trường ID key để xác định node
   * @param {any} parentID ID node cha
   * @param {any} hasCurrent Có lấy đơn vị hiện tại không?
   */
  checkIsParent(data, par, id, fieldID, parentID, isCurrent) {
    let isParent = !!isCurrent && par == id;
    let node = data.find(x => x[fieldID] == id);

    /**
     * Đệ quy tìm node cha của node hiện tại
     * @param {any} item Node hiện tại
     */
    let findParent = function (item) {
      /** Node cha */
      let parent = data.find(
        x =>
          x[fieldID] &&
          (x[fieldID] && x[fieldID].toLocaleLowerCase()) == (item[parentID] && item[parentID].toLocaleLowerCase()),
      );

      if (parent) {
        if (par == parent[fieldID]) {
          isParent = true;
        } else {
          /** Nếu có node cha thì đệ quy tìm các node cao hơn */
          findParent(parent);
        }
      }
    };

    findParent(node);
    return isParent;
  }

  /**
   * Hàm lấy ra moment để không phải import moment
   * NVTUAN1 17.08.2022
   * TODO Replace tất cả các chỗ đang import và sử dụng moment thành getMoment
   */
  getMoment(date) {
    //Nếu không truyền tham số ngày tháng thì return đối tượng moment ngày hiện tại
    if (!date) {
      return moment();
    }

    return moment(date);
  }

  /**
   * Hàm lấy ra moment, nếu không truyền tham số gì thì để trống
   * ntloc 22/06/2023
   */
  getMomentCustom(date) {
    //Nếu không truyền tham số ngày tháng thì return rỗng
    if (!date) {
      return '';
    }

    return moment(date);
  }

  /**
   * Build công thức sql load lên các tài khoản con chi tiết nhất thuộc tk cha đã được chọn
   * @param {array} arr Mảng truyền vào
   */
  buildOrOpera(arr, field, opera) {
    let rs = arr.reduce(
      (obj, item) => {
        let build = {
          Field: field,
          Operator: opera,
          Value: item,
        };
        obj.Stack && (obj.Stack.Ors = [build]);
        obj.Value || (obj.Value = build);
        return {Stack: build, Value: obj.Value};
      },
      {Value: undefined, Stack: undefined},
    );

    return rs.Value;
  }

  /**
   * Compare ngày
   * @author nnnam - 9/9/2022
   * ptthuy2 01.02.2024: bổ sung truyền format để format lại theo định dạng nếu cần thiết
   */
  compareDate(dte, compareDte, format = null) {
    let dte1 = moment(dte).format('YYYY-MM-DD');
    let dte2 = moment(compareDte).format('YYYY-MM-DD');
    if (format) {
      dte1 = moment(dte, format).format('YYYY-MM-DD');
      dte2 = moment(compareDte, format).format('YYYY-MM-DD');
    }
    return dte1 == dte2 ? MSConstant.Compare.Equal : dte1 > dte2 ? MSConstant.Compare.Than : MSConstant.Compare.Less;
  }

  /**
   * Compare ngày, giờ
   * @author tbngoc 11.08.2023
   */
  compareDateTime(dte, compareDte) {
    let dte1 = moment(dte).format('YYYY-MM-DD HH:mm:ss');
    let dte2 = moment(compareDte).format('YYYY-MM-DD HH:mm:ss');

    return dte1 == dte2 ? MSConstant.Compare.Equal : dte1 > dte2 ? MSConstant.Compare.Than : MSConstant.Compare.Less;
  }

  convertDateTime(date) {
    return moment(date).format('DD-MM-YYYY HH:mm:ss') + '';
  }
  /**
   * Compare giờ(đầu vào dạng dateTime)
   * @author tbngoc 11.08.2023
   */
  compareTimeOnly(dte, compareDte) {
    let dte1 = moment(dte).format('HH:mm:ss');
    let dte2 = moment(compareDte).format('HH:mm:ss');

    return dte1 == dte2 ? MSConstant.Compare.Equal : dte1 > dte2 ? MSConstant.Compare.Than : MSConstant.Compare.Less;
  }
  /**
   * Xử lý làm tròn số theo dboption
   * @param {*} optionsKey dboption key
   * @param {*} value
   * @returns
   * NCPHUOC 09/09/2022
   */
  roundDecimalDbOption(optionsKey, value) {
    let dbOptions = store.state[ModuleDbOption]?.dbOptions;
    const numberVal = Number(value);
    if (optionsKey && Number.isInteger(dbOptions[optionsKey]) && !isNaN(numberVal)) {
      return Number(numberVal.toFixed(dbOptions[optionsKey]));
    }
    return value;
  }

  /**
   * Gen tự động guid uuid v4
   */
  newGuid() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
      (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16),
    );
  }

  /**
   * Tạo object date từ string
   * @param {*} dateString
   * @param {*} format
   * nxhoa 14.10.2022
   */
  dateFromString(dateString, format) {
    var dateObject;
    try {
      var dateMomentObject = moment(dateString, format); // 1st argument - string, 2nd argument - format
      dateObject = dateMomentObject.toDate(); // convert moment.js object to Date object
    } catch (e) {}
    return dateObject;
  }

  /**
   * Thay đổi trạng thái của 1 dòng theo trạng thái trước đó
   * NCPHUOC 27/10/2022
   */
  changeStateRow(row) {
    if (row) {
      switch (row.state) {
        case MSConstant.ModelState.Insert:
        case MSConstant.ModelState.Empty:
          row.state = MSConstant.ModelState.Insert;
          break;
        case MSConstant.ModelState.Update:
        case MSConstant.ModelState.None:
          row.state = MSConstant.ModelState.Update;
          break;
        case MSConstant.ModelState.Delete:
          break;
        default:
          row.state = MSConstant.ModelState.Insert;
      }
    }
  }

  /**
   * Xử lý filter mảng
   * @author nnnam - 11/11/2022
   */
  filterArray(arr, filter) {
    let me = this;
    arr = arr || [];
    filter = filter || [];
    filter = Array.isArray(filter) ? filter : JSON.parse(filter);

    let rs = arr.filter(item => me.checkFilter(item, filter));
    return rs;
  }

  /**
   * Kiểm tra phần tử thỏa mãn filter
   * @author nnnam - 11/11/2022
   */
  checkFilter(item, filter) {
    let me = this;
    return filter.every(
      flt =>
        me.checkFilterByOpera(item[flt.Field], flt.Value, flt.Operator) || (flt.Ors && me.checkFilter(item, flt.Ors)),
    );
  }
  /**
   * Kiểm tra phần tử thỏa mãn điều kiền theo công thức
   * @author nnnam - 11/11/2022
   */
  checkFilterByOpera(value, compare, opera) {
    let rs = false;
    let str = value || '';
    switch (opera) {
      case MSConstant.FilterOperator.Contains:
        rs = str.includes(compare);
        break;
      case MSConstant.FilterOperator.Notcontains:
        rs = !str.includes(compare);
        break;
      case MSConstant.FilterOperator.StartsWith:
        rs = str.startsWith(compare);
        break;
      case MSConstant.FilterOperator.EndsWith:
        rs = str.endsWith(compare);
        break;
      case MSConstant.FilterOperator.Null:
        rs = value === null || value === undefined;
        break;
      case MSConstant.FilterOperator.NotNull:
        rs = value === null || value === undefined;
        break;
      case MSConstant.FilterOperator.Equals:
        rs = value === compare || (value === 1 && compare === true) || (value === 0 && compare === false);
        break;
      case MSConstant.FilterOperator.NotEquals:
        rs = value !== compare && !(value === 1 && compare === true) && !(value === 0 && compare === false);
        break;
      case MSConstant.FilterOperator.GreaterThan:
        rs = value > compare;
        break;
      case MSConstant.FilterOperator.GreaterThanEquals:
        rs = value >= compare;
        break;
      case MSConstant.FilterOperator.LessThan:
        rs = value < compare;
        break;
      case MSConstant.FilterOperator.LessThanEquals:
        rs = value <= compare;
        break;
      case MSConstant.FilterOperator.Between:
        compare = compare || [];
        rs = value >= compare[0] && value <= compare[1];
        break;
      case MSConstant.FilterOperator.In:
        compare = compare || [];
        rs = compare.includes(value);
        break;
      case MSConstant.FilterOperator.NotIn:
        compare = compare || [];
        rs = !compare.includes(value);
        break;
      default:
        rs = value === compare || (value === 1 && compare === true) || (value === 0 && compare === false);
        break;
    }
    return rs;
  }

  /**
   * Build sort method
   * @param {any} a
   * @param {any} b
   * NXCHIEN 18.02.2022
   */
  sortMethodAsc(a, b) {
    return a == b ? 0 : a > b ? 1 : -1;
  }

  /**
   * Build sort từ người dùng truyền vào
   * @param {any} direction asc hoặc desc
   * NXCHIEN 18.02.2022
   */
  sortMethodWithDirection(direction) {
    let me = this;
    if (direction === undefined || direction == 'asc') {
      return me.sortMethodAsc;
    } else {
      return function (a, b) {
        return -me.sortMethodAsc(a, b);
      };
    }
  }

  /**
   * Build đối tượng sort theo 1 điều kiện
   * @param {any} columnName
   * @param {any} direction
   * NXCHIEN 18.02.2022
   */
  sortMethodWithDirectionByColumn(columnName, direction) {
    let me = this;
    const sortMethod = me.sortMethodWithDirection(direction);
    return function (a, b) {
      return sortMethod(a[columnName], b[columnName]);
    };
  }

  /**
   * Build đối tượng sort với nhiều điều kiện
   * @param {any} sortArray [{ column: "column5", direction: "asc" },{ column: "column3", direction: "desc" }]
   * Ex: arr.sort(MISAUtil.sortMethodWithDirectionMultiColumn([{ column: "SortOrder", direction: "asc" }, { column: "MISACode", direction: "asc" }]));
   * EX: sortData: [{ sortField: "SortOrder", sortType: 1}]
   * NXCHIEN 18.02.2022
   */
  sortMethodWithDirectionMultiColumn(sortData) {
    let me = this;

    let sortArray = sortData.map(x => {
      return {
        column: x.sortField,
        direction: x.sortType == 1 ? 'desc' : 'asc',
      };
    });

    const sortMethodsForColumn = (sortArray || []).map(item =>
      me.sortMethodWithDirectionByColumn(item.column, item.direction),
    );
    return function (a, b) {
      let sorted = 0;
      let index = 0;
      while (sorted === 0 && index < sortMethodsForColumn.length) {
        sorted = sortMethodsForColumn[index++](a, b);
      }
      return sorted;
    };
  }

  /**
   * sort array theo tham số
   * EX sortArray(arr, [{ sortField: "SortOrder", sortType: 1}])
   */
  sortArray(arr, sort) {
    return arr.sort((a, b) => {
      return sort
        .map(x => {
          let valA = a[x.sortField];
          let valB = b[x.sortField];
          var opera = x.sortType == 1 ? -1 : 1;
          return (
            valA !== valB &&
            opera * ([valA, valB].some(t => typeof t === 'string') ? valA?.localeCompare(valB) : valA > valB ? 1 : -1)
          );
        })
        .find(x => x);
    });
  }

  /**
   * Check quyền
   * TTLONG 07/12/2022
   */
  checkPermission(permission) {
    const {Permission, IsAdmin, Context} = store.state[ModuleContext];
    const route = useRoute();
    const router = useRouter();

    //Nếu không có vai trò hoặc là lãnh đạo hoặc admin thì cho xem
    if (Context.IsLeader || IsAdmin) {
      permission.isPermission = true;
      return;
    }
    //Thực hiện check permision
    if (Permission) {
      const paths = route.path.split('/');
      if (paths.length > 0) {
        // ldduy sửa 17.1.2024
        // check xem paths.length - 1 có phải 1 guid không => nếu phải thì subSystem phải lấy lùi lại 1 lần / trên router
        var guidRegex = /^[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}$|^[0-9a-fA-F]{32}$/;
        const subSystemRouterKey = guidRegex.test(paths[paths.length - 1])
          ? paths[paths.length - 2]
          : paths[paths.length - 1];

        const subSystem = MSConstant.MappingRouterSubSystem[subSystemRouterKey];
        if (subSystem) {
          if (
            (Permission[subSystem] && Permission[subSystem].some(x => (x & MSConstant.Permission.View) === 0)) ||
            !Permission[subSystem]
          ) {
            permission.isPermission = true;
            return;
          }
          router.push({name: '403'});
          return;
        }
      }
      return;
    }
  }

  /**
   * check quyền dựa vào subsystemcode
   * tvhien 12.12.2022
   */
  checkPermissionWithSubSystemCode(permission, subSystemCode) {
    const me = this;
    const {Permission, IsAdmin, Context} = store.state[ModuleContext];

    //Nếu không có vai trò hoặc là lãnh đạo thì cho xem
    if (Context?.IsLeader) {
      if (permission === MSConstant.Permission.View) {
        return true;
      }
      return false;
    }

    //Không có hoặc khi là admin thì đều null
    if (!Permission) {
      return true;
    }

    if (!subSystemCode) {
      return true;
    }

    //permission có trong danh sách quyền hay không - tvhien - 07.12.2022
    let allowPermissions = Permission[subSystemCode];
    if (allowPermissions && allowPermissions.some(x => (x & permission) != 0)) {
      return false;
    }
    return true;
  }

  /**
   * Kiểm tra quyền của người dùng và hiển thị lên thông báo lỗi tương ứng
   * npcuong 20.03.2023
   */
  checkPermissionShowErrorMsg(action, subSystemCode) {
    const me = this;
    var res = me.checkPermissionWithSubSystemCode(action, subSystemCode);
    if (!res) {
      let msg = this.$t('i18nBaseForm.Validate.NotPermission');
      let title = this.$t('i18nBaseForm.Validate.TitleNotPermission');
      showError(msg, title);
      return false;
    }
    return true;
  }

  /**
   * check phân quyền dựa theo route truyền bào
   * tvhien 26.12.2022
   */
  checkPermissionByRoute(permission, route) {
    const {Permission, IsAdmin, Context} = store.state[ModuleContext];

    //Nếu không có vai trò hoặc là lãnh đạo hoặc admin thì cho xem
    if (Context.IsLeader || IsAdmin) {
      permission.isPermission = true;
    } else {
      //Thực hiện check permision
      if (Permission) {
        const paths = route.path.split('/');
        if (paths.length > 0) {
          const subSystemRouterKey = paths[paths.length - 1];
          const subSystem = MSConstant.MappingRouterSubSystem[subSystemRouterKey];
          if (subSystem) {
            if (
              (Permission[subSystem] && Permission[subSystem].some(x => (x & MSConstant.Permission.View) === 0)) ||
              !Permission[subSystem]
            ) {
              permission.isPermission = true;
            } else {
              location.href = '/403';
            }
          }
        }
      }
    }
  }

  /**
   * Kiểm tra người dùng có quyền truy cập hồ sơ k? kiểm tra trước khi routing tránh lỗi giao diện khi NSD nhập trục tiếp trên đường dẫn
   * dtnga3
   */
  checkPermissionDVC(toRouter) {
    var key = toRouter.params.key;
    var processKey = 'process';
    if (toRouter.path.contains('etreasury') && key && (key == 'dvcfile' || key == 'dcsdfile')) {
      if (authDVC.isDVCAuthenticated() && localStorage.DVCUser) {
        var userType = JSON.parse(localStorage.DVCUser).user_type;
        if (
          userType == MSConstant.DVCRole.HeadOfDepartment ||
          userType == MSConstant.DVCRole.DelegateHeadOfDepartment
        ) {
          location.href = location.href.replace(key, processKey);
        }
      } else {
        location.href = location.href.replace(key, processKey);
      }
    }
  }

  /**
   * Kiểm tra hiển thị thông báo top
   */
  checkHideNotificationWarningDate(toRouter) {
    var rs = false;
    if (toRouter.path.contains('initialinformationdeclaration') || toRouter.path.contains('dashboard')) {
      var showWarningDateTop = store.getters[ModuleContext + '/ShowWarningDateTop'];
      rs = showWarningDateTop || false;
    }
    store.dispatch(ModuleContext + '/atcShowWarningDateTopClient', rs);
  }

  /**
   * Thông báo lịch đào tạo qua Zoom
   * lttuan1 - 15.12.2023
   * @returns Trả về true nếu hiển thị thông báo, ngược lại trả về false
   */
  async handleHelpZoomNoti(callBack) {
    let keyCache = 'mimosa_zoom_noti';
    let dataCache = this.getLocalStorage(keyCache);
    const context = store.getters['context/Context'];

    if (!dataCache) {
      this.setLocalStorage(keyCache, true);
      let currentDate = new Date();
      // Thông báo hỗ trợ quyết toán qua zoom
      let helpSettlementZoom = window._helpSettlementZoom;
      let startDate = new Date(`${currentDate.getFullYear()}-${helpSettlementZoom.startDate}`);
      let endDate = new Date(`${currentDate.getFullYear()}-${helpSettlementZoom.endDate}`);
      if (this.dayBetween(currentDate, startDate, endDate)) {
        popupUtil.show('HelpSettlementZoomPopup');
        return true;
      }

      // Thông báo hỗ trợ đối chiếu kho bạc qua zoom
      let helpTreasuryZoom = window._helpTreasuryZoom;
      let listDay = [];
      for (let i = 0; i < helpTreasuryZoom.date.length; i++) {
        let arr = this.getPreviousDays(
          new Date(`${currentDate.getFullYear()}-${helpTreasuryZoom.date[i]}`),
          helpTreasuryZoom.skipWeekend,
          helpTreasuryZoom.previousDay,
        );
        arr = [
          ...arr,
          ...this.getNextDays(
            new Date(`${currentDate.getFullYear()}-${helpTreasuryZoom.date[i]}`),
            false,
            helpTreasuryZoom.nextDay,
          ),
        ];
        if (arr.includes(moment(currentDate).format('YYYY-MM-DD'))) {
          arr = arr.sort();
          listDay = [...arr];
          break; // Thoát khỏi vòng lặp
        }
      }
      // Nếu có list ngày cần hiển thị thông báo thì mới vào hàm
      if (listDay.length > 0 && this.dayBetween(currentDate, listDay[0], listDay[listDay.length - 1])) {
        // Check số phiên đăng nhập
        let param = {
          user_id: context.UserID,
          from_date: listDay[0],
          to_date: listDay[listDay.length - 1],
        };
        var res = await accountAPI.UpdateLoginCount(param);
        if (res && res.login_count <= helpTreasuryZoom.period) {
          popupUtil.show('HelpTreasuryZoomPopup');
          return true;
        }

        if (callBack && typeof callBack == 'function') {
          callBack();
        }
        return false;
      }

      // Thông báo Hàng tuần có các buổi đào tạo khác
      // Không hiển thị 2 thông báo trên thì mới hiển thị thông báo này
      let helpTrainZoom = window._helpTrainZoom;
      // Check xem có phải thứ 6 không
      if (currentDate.getDay() == helpTrainZoom.date) {
        // Có thì tính 4 ngày tiếp theo
        var arr = this.getNextDays(currentDate, helpTrainZoom.skipWeekend, helpTrainZoom.nextDay);
        // Cập nhật lên db
        let param = {
          user_id: context.UserID,
          from_date: arr[0],
          to_date: arr[arr.length - 1],
        };
        res = await accountAPI.UpdateLoginCount(param);
      } else {
        let param = {
          user_id: context.UserID,
          from_date: currentDate,
          to_date: currentDate,
        };
        var res = await accountAPI.UpdateLoginCount(param);
      }
      // Hiển thị popup
      if (
        res &&
        res.from_date.getTime() != res.to_date.getTime() &&
        res.login_count &&
        res.login_count <= helpTrainZoom.period
      ) {
        popupUtil.show('HelpTrainZoomPopup');
        return true;
      }
    }
    return false;
  }

  /**
   * Thông báo hiên thị popup HƯỚNG DẪN NHẬP CHỨNG TỪ NĂM...
   * dqdat1 - 18.12.2023
   */
  async handleNotificationBannerHelpConvertData() {
    let keyCache = 'mimosa_noti_banner_help_convert_data';
    let dataCache = this.getLocalStorage(keyCache);
    if (!dataCache) {
      let currentDate = new Date();

      let bannerHelpConvertData = window._bannerHelpConvertData;
      let startDate = new Date(`${currentDate.getFullYear()}-${bannerHelpConvertData.startDate}`);
      let endDate = new Date(`${currentDate.getFullYear()}-${bannerHelpConvertData.endDate}`);

      let postedDate = await store.getters['context/PostedDate'];
      if (postedDate < startDate && currentDate >= startDate && currentDate <= endDate) {
        let res = await notificationAPI.OffBannerInstruct(startDate);
        if (!res) {
          popupUtil.show('BannerHelpConvertDataPopup');
        }
      }
    }
    this.setLocalStorage(keyCache, true);
  }

  /**
   * Kiểm tra ngày có nằm giữa 2 ngày không
   */
  dayBetween(date, sdate, edate) {
    date = new Date(date);
    sdate = new Date(sdate);
    edate = new Date(edate);
    date.setHours(0, 0, 0, 0);
    sdate.setHours(0, 0, 0, 0);
    edate.setHours(0, 0, 0, 0);
    return date >= sdate && date <= edate;
  }

  /**
   * Lấy n ngày trước ngày truyền vào trả về list dạng đã format ("YYYY-MM-DD")
   * lttuan1 - 15.12.2023
   */
  getPreviousDays(date, skipWeekend, previousDay) {
    const result = [];
    let daysFound = 0;
    while (daysFound < previousDay) {
      date.setDate(date.getDate() - 1); // Giảm một ngày
      if (!skipWeekend || (date.getDay() !== 0 && date.getDay() !== 6)) {
        // bỏ qua thứ 7,chủ nhật
        result.push(moment(new Date(date)).format('YYYY-MM-DD')); // Thêm ngày vào mảng result
        daysFound++;
      }
    }
    return result;
  }

  /**
   * Lấy n ngày sau ngày truyền vào trả về list dạng đã format ("YYYY-MM-DD")
   * lttuan1 - 15.12.2023
   */
  getNextDays(date, skipWeekend, nextDay) {
    const result = [moment(new Date(date)).format('YYYY-MM-DD')];
    let daysFound = 0;
    while (daysFound < nextDay - 1) {
      date.setDate(date.getDate() + 1); // Giảm một ngày
      if (!skipWeekend || (date.getDay() !== 0 && date.getDay() !== 6)) {
        // bỏ qua thứ 7,chủ nhật
        result.push(moment(new Date(date)).format('YYYY-MM-DD')); // Thêm ngày vào mảng result
        daysFound++;
      }
    }
    return result;
  }

  /**
   * Xử lý thông báo
   * DMNGOC 13.10.2023
   */
  async handleUpgradeNotiStatus() {
    // Xử lý thông báo
    const {Context} = store.state[ModuleContext];
    let databaseId = Context.DatabaseId;
    let keyCache = `upgrade_noti_popup_${databaseId}`;
    let data = '';
    if (localStorage[this.processLocalStorageKey(keyCache)]) {
      data = JSON.parse(this.getLocalStorage(keyCache));
    } else {
      data = await databaseAPI.getNotiStatus(databaseId);
    }
    if (data != null && data.noti_upgrade_status && data.noti_upgrade_status != MSConstant.NotiUpgradeStatus.Hide) {
      if (data.noti_upgrade_status == MSConstant.NotiUpgradeStatus.Prepare) {
        // Mở popup
        popupUtil.show('MaintainPopup', {
          fromDate: data.from_date,
          toDate: data.to_date,
          data: data,
          keyCache: keyCache,
          firstLoad: true,
        });

        var date = new Date();
        var miliseconds = data.from_date.getTime() - date.getTime();
        // Đúng giờ bắt đầu thì hiện page nâng cấp
        setTimeout(() => {
          window.location.reload();
        }, miliseconds);
      } else {
        // Mở page nâng cấp
        window.location.reload();
      }
    } else {
      // Hiển thị các thông báo khác (bắt đầu từ chuyển đổi dữ liệu nếu có - thoe PBI 690521)
      EventBusGlobal.$emit(GlobalEventName.raiseConvertNotification);
    }
  }

  /**
   * Xử lý thông báo cập nhật thông tư 24
   * @param callBack hàm thực hiện nếu không hiển thị
   */
  async handleNotifyUpdateTT24(callBack) {
    let keyCache = `mimosa_show_notify_update_tt24`;
    let dataCache = this.getLocalStorage(keyCache);
    let isShow = false;
    if (!dataCache && store.state[ModuleContext]?.Context?.IsCreateTT24) {
      let data = await notificationAPI.GetNotifyUpdateTT24();

      if (data?.IsShow) {
        popupUtil.show('NotifyUpdateTT24', {});
        isShow = true;
      }
    }
    this.setLocalStorage(keyCache, true);
    if (!isShow && callBack && typeof callBack == 'function') {
      callBack();
    }
  }

  /**
   * Xử lý show popup hóa đơn MISA cấp
   * @param callBack hàm thực hiện nếu không hiển thị popup hóa đơn MISA cấp
   * bhtuyen 21/11/2023
   */
  async handleFinalcialInvoiceNoti(callBack) {
    let keyCache = 'mimosa_finalcial_invoice_noti';
    let dataCache = this.getLocalStorage(keyCache);
    let isShow = false;
    if (!dataCache) {
      let debtNotPayment = await integrationACTApi.GetDebtNotPaymentInvoiceToACT(); // Lấy danh sách hóa đơn chưa thanh toán
      if (debtNotPayment.length > 0) {
        popupUtil.show('FinancialInvoiceNotiPopup', {debtNotPayment: debtNotPayment});
        isShow = true;
      }
      // Nếu không có danh sách hóa đơn chưa thanh toán thì mới hiển thị danh sách hóa đơn đã hết hạn
      let debtInvoiceOutOfDate = await integrationACTApi.GetDebtInvoiceOutOfDate(); // Lấy danh sách hóa đơn hết hạn
      if (debtInvoiceOutOfDate.length > 0) {
        popupUtil.show('NotiSystemPopup', {debtInvoiceOutOfDate: debtInvoiceOutOfDate});
        isShow = true;
      }
    }

    this.setLocalStorage(keyCache, true);
    if (!isShow && callBack && typeof callBack == 'function') {
      callBack();
    }
  }
  /**
   * Xử lý thông báo cập nhật thông tư 23
   * @param callBack hàm thực hiện nếu không hiển thị
   * TVDAT 29/05/2023
   * modifiedBy dtnga3 (19.11.2024) Bỏ hiển thị thôngbáo KBĐT đi vì đã được xét hiển thị trước đó rồi
   */
  async handleNotificationTT23(ignoreCheckAgreement, callBack) {
    let dbOptions = await store.state[ModuleDbOption]?.dbOptions;
    let isShow = false;
    //Không kết nối QLTS thì mới show
    if (dbOptions && !dbOptions.UseQLTSVN) {
      let postedDate = await store.getters['context/PostedDate'];
      //Thông báo cập nhật thông tư 23
      //Check xem năm hạch toán >= 2023, chưa cập nhật thông tư và chưa show thông báo trong phiên đăng nhập
      const data = await store.getters['context/Context'];

      try {
        let _indexDb = new IndexedDB();
        // Lấy dữ liệu thì cache thông tin thông tư 23 theo databaseid và trang thái cập nhật tt23
        let circularInfo = await _indexDb.get('CircularInfo');
        // check dữ liệu hiện tại đã được cập nhật tt23 chưa 
        let isCircularInfo = false;
        // Nếu có cache thì tìm xem trong cache có databaseid hiện tại không
        if(circularInfo){
          // Lấy trạng thái cập nhật thông tin thông tư 23 của dữ liệu hiện tại
          let stateCircularInfo = circularInfo[data.DatabaseID];
          // Nếu không có cache thông tin thông tư 23 của databaseid hiện tại thì call api lấy thông tin
          if(stateCircularInfo == undefined){
            // Lấy thông tin các thông tư 
            let getcircularInfo = await buTranserAPI.getCircularInfo();
            if(getcircularInfo && getcircularInfo.length > 0){
              // Lọc thông tin thông tư 23 xem đã cập nhật thông tư 23 chưa
              let isUpdateCircular23 = getcircularInfo.find(item => item.circular_id == 4)?.is_update || false;
              // Lưu thông tin thông tư 23 của databaseid hiện tại vào cache
              circularInfo[data.DatabaseID] = isUpdateCircular23;
              _indexDb.set('CircularInfo', JSON.stringify(circularInfo));
              isCircularInfo = isUpdateCircular23;
            }
          } 
          else{
            isCircularInfo = stateCircularInfo;
          }
        }
        // Nếu trong cache không có thì call API lấy thông tin
        else{
          // Lấy thông tin các thông tư 
          let getcircularInfo = await buTranserAPI.getCircularInfo();
          // Lọc thông tin thông tư 23 xem đã cập nhật thông tư 23 chưa
          let isUpdateCircular23 = getcircularInfo?.find(item => item.circular_id == 4)?.is_update || false;
          // Lưu thông tin thông tư 23 của databaseid hiện tại vào cache
          let objCircularInfo = {};
          objCircularInfo[data.DatabaseID] = isUpdateCircular23;
          // Lưu thông tin thông tư 23 vào cache
          _indexDb.set('CircularInfo', JSON.stringify(objCircularInfo));
          isCircularInfo = isUpdateCircular23;
        }
        //Check trạng thái xác nhận sử dụng
        // const checkAgreement = await agreementContractApi.checkAgreementApp();
        // DVMINH Thay đổi luồng chuyển xác nhận sang MISAID rồi nên không cần check backend nữa
        // Nếu chắc chắn có thông báo xác nhận sử dụng thì không cần quan tâm phần check trạng thái sử dụng nữa
        if (ignoreCheckAgreement) {
          let keyCache = 'mimosa_update_tt23_noti';
          let dataCache = this.getLocalStorage(keyCache);
          // Nếu không có cache - chưa cập nhật thông tư 23 - ngày hạch toán >= 2023
          if (!dataCache && !isCircularInfo && postedDate && postedDate.getFullYear() >= 2023) {
            popupUtil.show('UpdateTT23Popup');
            isShow = true;
          } else {
            const dataCacheParse = JSON.parse(dataCache);
            // Nếu có cache - chưa cập nhật tt23(trên cache trình duyệt) - chưa cập nhật cache server và ngày hạch toán >= 2023
            if (
              dataCacheParse &&
              !dataCacheParse[`is_show_${data.DatabaseId}`] &&
              !isCircularInfo &&
              postedDate &&
              postedDate.getFullYear() >= 2023
            ) {
              popupUtil.show('UpdateTT23Popup');
              isShow = true;
            }
          }


        }
      } catch (error) {}
    }
    if (!isShow && callBack && typeof callBack == 'function') {
      callBack();
    }
  }

  /**
   * Hiển thị thông báo KBĐT, trả về kết quả có hiển thị hay không để xử lý hiển thị thông báo tiếp theo
   * @param callBack hàm thực hiện nếu không hiển thị thông báo KBĐT
   * dtnga3 (18.11.2024)
   */
  async handleKBDTNoti(callBack) {
    const {Context} = store.state[ModuleContext];
    let databaseId = Context.DatabaseId;
    let keyCache = `upgrade_noti_popup_${databaseId}`;
    let data = '';
    if (localStorage[this.processLocalStorageKey(keyCache)]) {
      data = JSON.parse(this.getLocalStorage(keyCache));
    } else {
      data = await databaseAPI.getNotiStatus(databaseId);
    }
    if (data != null && data.noti_upgrade_status && data.noti_upgrade_status != MSConstant.NotiUpgradeStatus.Hide) {
      if (callBack && typeof callBack == 'function') {
        callBack();
      }
    } else {
      await this.initKBDTNoti(callBack);
    }
  }

  /**
   * Xử lý thông báo KBDT
   */
  async initKBDTNoti(callBack) {
    const context = store.getters['context/Context'];
    let isShowNoti = false;
    if (
      context.CreateDataType == MSConstant.CreateDataType.CreateData ||
      context.CreateDataType == MSConstant.CreateDataType.ConvertDesktop
    ) {
      var dbOptions = await store.state[ModuleDbOption]?.dbOptions;
      if (dbOptions && !popupUtil.get('BannerKBDTPopup')) {
        await dVCFileAPI.checkShowCompanyDVCNoti(dbOptions?.CompanyCode).then(res => {
          switch (res) {
            case MSConstant.CompanyDVCNotification.ShowUseDVCNotification: {
              isShowNoti = true;
              popupUtil.show('BannerKBDTPopup', {isRegister: false});
              break;
            }
            case MSConstant.CompanyDVCNotification.ShowNotUseDVCNotification: {
              isShowNoti = true;
              popupUtil.show('BannerKBDTPopup', {isRegister: true});
              break;
            }
            default:
              break;
          }
        });
      }
    }
    if (!isShowNoti) {
      if (callBack && typeof callBack == 'function') {
        callBack();
      }
    }
  }

  /**
   * Kiểm tra hiển thị thông báo live chat
   * @returns true: đủ đk hiển thị, false: Không đủ đk hiển thị
   * dtnga3 (18.11.2024)
   */
  async checkShowLiveChatNoti(callBack) {
    var isShow = false;
    const context = store.getters['context/Context'];
    if (
      context.CreateDataType == MSConstant.CreateDataType.CreateData ||
      context.CreateDataType == MSConstant.CreateDataType.ConvertDesktop
    ) {
      // do gọi ngay sau khi valide cache Dboption nên chắc chắn là dữ liệu mới nhất
      let data = await store.dispatch('dbOption/getDbOptions', {reload: false});
      if (data && data.ShowedIntroduceLiveChat != undefined) {
        isShow = !data.ShowedIntroduceLiveChat;
      } else {
        isShow = true;
      }
    }
    if (!isShow && callBack && typeof callBack == 'function') {
      callBack();
    }
    return isShow;
  }

  /**
   * Kiểm tra hiên thị thông báo nghiệp vụ, thiết lập,...
   * @param isCheckOnly chỉ kiểm tra có hiển thị hay không, không thực hiện cập nhật lại
   * @returns true: đã hiển thị rổi không hiển thị nữa, false: chưa hiển thị lần nào
   * dtnga3 (18.11.2024)
   */
  async checkAutoShowStep(isCheckOnly) {
    const context = store.getters['context/Context'];
    if (
      context.CreateDataType == MSConstant.CreateDataType.CreateData ||
      context.CreateDataType == MSConstant.CreateDataType.ConvertDesktop
    ) {
      let disAuto = await registerAPI.showStep({
        databaseId: context.DatabaseId,
        tenantId: context.TenantId,
        userId: context.UserID,
      });

      if (!disAuto) {
        if (!isCheckOnly) {
          registerAPI.updateShowStep({
            databaseId: context.DatabaseId,
            tenantId: context.TenantId,
            userId: context.UserID,
            autoShow: true,
          });
        }
        // chưa hiển thị lần nào
        return false;
      }
    }
    // đã hiển thị rồi, không hiển thị nữa
    return true;
  }

  /**
   * Hàm sắp xếp phòng ban giống với thứ tự ở danh mục phòng ban
   * dqvinh 16.1.2022
   */
  sortDepartments(arr = [], idField = 'department_id', parentIdField = 'parent_id') {
    if (arr?.length > 0) {
      let dataTree = this.nomalizeDataTree(arr, idField, parentIdField);

      const isTree = true;
      let datax = this.getBodyData(dataTree, isTree);

      //Xử lý nếu số lượng bản ghi lớn hơn max thì sẽ cụp đến level 2
      if (datax.length > MSConstant.DefaultMaxRecord.GridTree) {
        datax.forEach(item => {
          if (item.level > 2) {
            item.isHide = true;
          }

          if (item.level === 2) {
            item.expanded = false;
          }
        });
      }
      return datax;
    }
    return [];
  }

  /**
   * Cập nhật title page khi mở màn hình
   */
  updateTitlePageWhenOpenScreen(screenCode) {
    const {_cacheTitlePage} = window;
    if (Array.isArray(_cacheTitlePage) && screenCode) {
      const titlePage = this.getScreen(screenCode);
      if (titlePage) {
        const {Context} = store.state[ModuleContext];
        const companyName = Context.TenantName;
        const fullTitle = `${titlePage} | ${companyName} | Mimosa Online`;
        _cacheTitlePage.push(fullTitle);
        document.title = fullTitle;
      }
    }
  }

  /**
   * Cập nhật title page khi đóng màn hình
   */
  updateTitlePageWhenCloseSreen(screenCode) {
    const {_cacheTitlePage} = window;
    if (Array.isArray(_cacheTitlePage) && screenCode) {
      const titlePage = this.getScreen(screenCode);
      const lastIndex = _cacheTitlePage.length - 1;
      //Nếu index cuối cùng chứa title hiện tại của screen
      if (_cacheTitlePage[lastIndex] && _cacheTitlePage[lastIndex].contains(titlePage)) {
        _cacheTitlePage.pop();
        const titlePage = _cacheTitlePage[lastIndex - 1];
        if (titlePage) {
          document.title = titlePage;
        }
      }
    }
  }

  getScreen(code) {
    if (!code) {
      console.error('Chưa cấu hình screen code tại màn hình');
      throw 'Chưa cấu hình screen code tại màn hình';
    }
    if (code === 'login') {
      return 'Đăng nhập';
    }
    const localize = i18n;
    const screenName = localize.t(`i18nMonitor.ScreenName.${code}`);
    if (!screenName) {
      // return '';
      console.error('Chưa định nghĩa screenName tại i18n');
      throw 'Chưa định nghĩa screenName tại i18n';
    }
    if (screenName.indexOf('i18nMonitor') !== -1) {
      // return '';
      console.error('Chưa định nghĩa screenName tại i18n');
      throw 'Chưa định nghĩa screenName tại i18n';
    }
    return screenName;
  }

  /**
   * Factory để lấy thông tin popup cần show khi chọn chứng từ(Tùy chọn in)
   * tbngoc 22.02.2023
   */
  formChooseReportSettingFactory(refType) {
    switch (refType) {
      case MSConstant.RefType.BUPlanWithdrawCash:
      case MSConstant.RefType.BUPlanWithdrawDeposit:
      case MSConstant.RefType.BUPlanWithdrawTransfer:
      case MSConstant.RefType.BUPlanWithdrawSalaryTransfer:
        return 'ChooseVoucherReportSettingBuPlanWithDraw';
      case MSConstant.RefType.BUTransfer:
      case MSConstant.RefType.BUTransferDeposit:
      case MSConstant.RefType.BUTransferSalary:
      case MSConstant.RefType.BUTransferInsurrance:
      case MSConstant.RefType.BUTransferPurchase:
      case MSConstant.RefType.BUTransferVendorPayment:
      case MSConstant.RefType.BUTreasuryFundTransferSalary:
      case MSConstant.RefType.BUTreasuryFundTransferInsurancePayment:
      case MSConstant.RefType.BUTransferFixedAsset:
        return 'ChooseVoucherReportSettingBuTransfer';
      case MSConstant.RefType.CAReceiptPlanWithdraw:
        return 'ChooseVoucherReportCAReceiptPlanWithdrawList';
      case MSConstant.RefType.CAReceipt:
      case MSConstant.RefType.CAReceiptPlanWithdraw:
      case MSConstant.RefType.CAReceiptWithdraw:
      case MSConstant.RefType.CAReceiptCustomer:
      case MSConstant.RefType.CAReceiptFixedAsset:
      case MSConstant.RefType.CAReceiptSale:
        return 'ChooseVoucherReportCAReceiptList';
      case MSConstant.RefType.CAPayment:
      case MSConstant.RefType.CAPaymentDeposit:

      case MSConstant.RefType.CAPaymentPurchase:
      case MSConstant.RefType.CAPaymentVendor:
      case MSConstant.RefType.CAPaymentSalary:
      case MSConstant.RefType.CAPaymentFixedAsset:
        return 'ChooseVoucherReportCAPayment';
      case MSConstant.RefType.BADeposit:
      case MSConstant.RefType.BADepositCustomer:
      case MSConstant.RefType.CAPaymentDeposit:
      case MSConstant.RefType.BADepositSale:
        return 'ChooseVoucherReportBADepositTab';
      case MSConstant.RefType.BAWithDraw:
      case MSConstant.RefType.BAWithDrawSalary:
      case MSConstant.RefType.BAWithdrawVendor:
      case MSConstant.RefType.BAWithdrawPurchase:
      case MSConstant.RefType.BAWithDrawFixedAsset:
        return 'ChooseVoucherReportBAWithdrawTab';
      case MSConstant.RefType.BABankTransfer:
        return 'ChooseVoucherReportBABankTransferTab';
      case MSConstant.RefType.INInward:
      case MSConstant.RefType.PUInvoice:
      case MSConstant.RefType.INInwardFromINAdjustment:
      case MSConstant.RefType.INInwardFromINAdjustmentChangeAmount:
        return 'ChooseVoucherReportINInwardTab';
      case MSConstant.RefType.INOutward:
      case MSConstant.RefType.INOutwardFromINAdjustment:
      case MSConstant.RefType.INOutwardFromINAdjustmentChangeAmount:
        return 'ChooseVoucherReportInOutwardList';
      case MSConstant.RefType.INTransfer:
        return 'ChooseVoucherReportINTransferList';
      case MSConstant.RefType.INAdjustment:
        return 'ChooseVoucherINAdjustmentList';
      case MSConstant.RefType.FADevaluation:
        return 'ChooseVoucherFADevaluationList';
      case MSConstant.RefType.FADecrement:
        return 'ChooseVoucherFADecrementList';
      case MSConstant.RefType.SAInvoice:
        return 'ChooseVoucherReportSAInvoiceTab';
      case MSConstant.RefType.SAReturn:
        return 'ChooseVoucherReportSAReturnList';
      case MSConstant.RefType.GLGeneralVoucher:
      case MSConstant.RefType.GLProvisionalTaxInComeEnterprise:
      case MSConstant.RefType.GLFinalTaxInComeEnterprise:
        return 'ChooseVoucherGLVoucherTab';
      case MSConstant.RefType.BATransferDeposit:
      case MSConstant.RefType.BATransferWithdraw:
        return 'ChoosevoucherReportBATransferTab';
      case MSConstant.RefType.BUCommitmentRequest:
        return 'ChooseVoucherReportBUCommitmentRequestTab';
      case MSConstant.RefType.BUCommitmentAdjustment:
        return 'ChooseVoucherReportBUCommitmentAdjustmentTab';
      case MSConstant.RefType.BUPlanCancel:
        return 'ChooseVoucherReportBUPlanCancelTab';
      case MSConstant.RefType.GLPostedVoucher:
        return 'ChooseVoucherReportGLPostedTab';
      case MSConstant.RefType.GLProfitLossTransfer:
        return 'ChooseVoucherReportGLProfitLossTransferTab';
      case MSConstant.RefType.GLEndYearTransfer:
        return 'ChooseVoucherReportGLEndYearTransferTab';
      case MSConstant.RefType.GLBeginningYearTransfer:
        return 'ChooseVoucherReportGLBeginningYearTransferTab';
      case MSConstant.RefType.FAAdjustment:
        return 'ChooseVoucherReportFixedAssetAdjustment';
      case MSConstant.RefType.CAReceiptPlanWithdraw:
        return 'ChooseVoucherReportCAReceiptPlanWithdrawList';
      case MSConstant.RefType.CAReceipt:
      case MSConstant.RefType.CAReceiptPlanWithdraw:
      case MSConstant.RefType.CAReceiptWithdraw:
      case MSConstant.RefType.CAReceiptCustomer:
      case MSConstant.RefType.CAReceiptFixedAsset:
      case MSConstant.RefType.CAReceiptSale:
        return 'ChooseVoucherReportCAReceiptList';
      case MSConstant.RefType.BADeposit:
      case MSConstant.RefType.BADepositCustomer:
      case MSConstant.RefType.CAPaymentDeposit:
      case MSConstant.RefType.BADepositSale:
        return 'ChooseVoucherReportBADepositTab';
      case MSConstant.RefType.BABankTransfer:
        return 'ChooseVoucherReportBABankTransferTab';
      case MSConstant.RefType.INInward:
      case MSConstant.RefType.PUInvoice:
      case MSConstant.RefType.FAPurchaseInvoice:
        return 'ChooseVoucherReportINInwardTab';
      case MSConstant.RefType.INOutward:
      case MSConstant.RefType.INOutwardFromINAdjustment:
      case MSConstant.RefType.INOutwardFromINAdjustmentChangeAmount:
        return 'ChooseVoucherReportInOutwardList';
      case MSConstant.RefType.INTransfer:
        return 'ChooseVoucherReportINTransferList';
      case MSConstant.RefType.FADevaluation:
        return 'ChooseVoucherFADevaluationList';
      case MSConstant.RefType.SAInvoice:
        return 'ChooseVoucherReportSAInvoiceTab';
      case MSConstant.RefType.GLGeneralVoucher:
      case MSConstant.RefType.GLProvisionalTaxInComeEnterprise:
      case MSConstant.RefType.GLFinalTaxInComeEnterprise:
        return 'ChooseVoucherGLVoucherTab';
      case MSConstant.RefType.BATransferDeposit:
      case MSConstant.RefType.BATransferWithdraw:
        return 'ChoosevoucherReportBATransferTab';
      case MSConstant.RefType.BUCommitmentRequest:
        return 'ChooseVoucherReportBUCommitmentRequestTab';
      case MSConstant.RefType.BUCommitmentAdjustment:
        return 'ChooseVoucherReportBUCommitmentAdjustmentTab';
      case MSConstant.RefType.BUPlanCancel:
        return 'ChooseVoucherReportBUPlanCancelTab';
      case MSConstant.RefType.GLEndYearTransfer:
        return 'ChooseVoucherReportGLEndYearTransferTab';
      case MSConstant.RefType.GLBeginningYearTransfer:
        return 'ChooseVoucherReportGLBeginningYearTransferTab';
      case MSConstant.RefType.FAIncrement:
        return 'ChooseVoucherFAIncrementList';
      // return 'ChooseVoucherFAPurchaseIncrementList';
      case MSConstant.RefType.BUPlanAdjustment:
        return 'ChooseVoucherBUPlanAdjustmentTab';
      case MSConstant.RefType.FADepreciation:
        return 'ChooseVoucherReportFADepreciation';
      case MSConstant.RefType.BADepositFixedAsset:
        return 'ChooseVoucherReportCAReceiptFixedAsset';
      case MSConstant.RefType.GLVoucherSummaryTable:
        return 'ChooseVoucherReportGLVoucherSummaryTable';
      case MSConstant.RefType.BUPlanReceipt:
      case MSConstant.RefType.BUPlanSupplement:
        return 'ChooseVoucherReportBUPlanReceiptTab';
      case MSConstant.RefType.FAVoucherDepreciation:
      case MSConstant.RefType.FAVoucherIncreament:
      case MSConstant.RefType.FAVoucherAdjustment:
      case MSConstant.RefType.FAVoucherDepreciate:
      case MSConstant.RefType.FAVoucherDecrement:
        return 'ChooseVoucherReportQLTSVoucher';
      case MSConstant.RefType.GLPayrollExpense:
        return 'ChooseVoucherReportGLPayrollExpenseTab';
      default:
        return '';
    }
  }

  removeLastComma(str) {
    return str.replace(/,(\s+)?$/, '');
  }
  /**
   * Đóng frame in báo cáo
   * tbngoc 22.02.2023
   */
  closePrintIframe() {
    const iframes = window.frames['reportPreview'];
    if (iframes) {
      if (HTMLCollection.prototype.isPrototypeOf(iframes)) {
        Array.from(iframes).forEach(function (element) {
          element.remove();
        });
      } else {
        iframes.remove();
      }
    }
  }
  /**
   *Show frame in báo cáo
   * tbngoc 22.02.2023
   */
  printPreviewReport(report, result, api = null) {
    if (api == null) {
      api = reportSettingAPI;
    }
    const previewLink = api.getPrintLink(result, this.removeUnicode(report.reportName));
    const iFramePDF = document.createElement('iframe');
    try {
      document.body.appendChild(iFramePDF);
      iFramePDF.src = previewLink;
      iFramePDF.id = 'reportPreview';
      iFramePDF.onload = () => {
        iFramePDF.contentWindow.print();
        this.unmask();
      };
    } catch (err) {
    } finally {
      this.unmask();
    }
  }
  /**
   * Lưu thông in đã in với chứng từ in trực tiếp k có form tham số của tùy chọn in
   * tbngoc 22.02.2023
   */
  async savePrintSingleReportConfigPrint(reportInfo, modelInfo) {
    const me = this;
    let dataReportPrint = [];
    try {
      // Lấy thông tin những chứng từ đã in
      dataReportPrint = await reportSettingAPI.getReportConfigPrint(reportInfo.ref_type, reportInfo.report_id);
    } catch (err) {
      console.log(err);
    }

    if (dataReportPrint) {
      let payloadSave = [];
      const dataExist = dataReportPrint?.find(
        x => x.ref_id === modelInfo.ref_id && x.report_id === reportInfo.report_id,
      );
      let disableAllowBatching = false;
      if (reportInfo.disable_options) {
        const disableOptionObject = JSON.parse(reportInfo.disable_options);
        if (disableOptionObject && disableOptionObject['allow_batch_printing']) {
          disableAllowBatching = true;
        }
      }
      if (!dataExist && !disableAllowBatching) {
        payloadSave.push({
          ref_id: modelInfo.ref_id,
          report_id: reportInfo.report_id,
          ref_type: reportInfo.ref_type,
          ref_no: modelInfo.ref_no,
        });
      }
      try {
        if (payloadSave && payloadSave.length > 0) {
          await reportSettingAPI.saveReportConfigPrint(payloadSave);
        }
      } catch (err) {
        console.log(err);
      } finally {
      }
    }
  }
  /**
   * Lưu thông tin chứng từ đã in với chứng từ có form tham số
   * tbngoc 22.02.2023
   */
  async savePrintMultipleReportsConfigPrint(reportInfo, selectedVoucher, modelInfo) {
    const me = this;
    let dataReportPrint = [];
    try {
      dataReportPrint = await reportSettingAPI.getReportConfigPrint(reportInfo.ref_type, reportInfo.report_id);
    } catch (err) {
      console.log(err);
    } finally {
    }

    if (dataReportPrint) {
      let payloadSave = [];
      if (!selectedVoucher) {
        const dataExist = dataReportPrint?.find(
          x => x.ref_id === modelInfo.ref_id && x.report_id === reportInfo.report_id,
        );
        let disableAllowBatching = false;
        if (modelInfo.disable_options) {
          const disableOptionObject = JSON.parse(modelInfo.disable_options);
          if (disableOptionObject && disableOptionObject['allow_batch_printing']) {
            disableAllowBatching = true;
          }
        }
        if (!dataExist && !disableAllowBatching) {
          payloadSave.push({
            ref_id: modelInfo.ref_id,
            report_id: reportInfo.report_id,
            ref_type: reportInfo.ref_type,
            ref_no: modelInfo.ref_no,
          });
        }
      } else {
        if (Array.isArray(selectedVoucher)) {
          selectedVoucher.forEach(item => {
            let dataExist = dataReportPrint.find(x => x.ref_id === item.ref_id && x.report_id === reportInfo.report_id);
            if (!dataExist) {
              payloadSave.push({
                ref_id: item.ref_id,
                report_id: reportInfo.report_id,
                ref_type: reportInfo.ref_type,
                ref_no: item.ref_no,
              });
            }
          });
        }
      }

      try {
        // Lưu thông tin đã in
        if (payloadSave && payloadSave.length > 0) {
          await reportSettingAPI.saveReportConfigPrint(payloadSave);
        }
      } catch (err) {
        console.log(err);
      } finally {
      }
    }
  }
  /**
   * Thực hiện bind dữ liệu khi mở tùy chọn in
   * tbngoc 28.02.2023
   */
  handleBindSettingReport(refType, model, dbOptions, selected) {
    if (model) {
      let disableOptions = {};
      if (selected.disable_options) {
        disableOptions = JSON.parse(selected.disable_options);
      }
      const cloneDbOptions = _.cloneDeep(dbOptions);

      const printPatch = this.getLocalStorage('PrintBatch') == 'true';
      const printPreview = this.getLocalStorage('PrintPreview') == 'true';

      model.view_receipt_full_amount = this.normalizeBooleanValue(cloneDbOptions.IsGetEnoughMoney);
      let value = false;
      // Đã trao đổi với BA xong mới zem đoạn này
      // switch (refType) {
      //   case MSConstant.RefType.BUPlanWithdrawCash:
      //   case MSConstant.RefType.BUPlanWithdrawDeposit:
      //   case MSConstant.RefType.CAReceipt:
      //   case MSConstant.RefType.CAReceiptPlanWithdraw:
      //   case MSConstant.RefType.BADeposit:
      //   case MSConstant.RefType.BUTransferDeposit:
      //     value = cloneDbOptions.AddInfoFromLincense;
      //     break;
      // }
      value = cloneDbOptions.AddInfoFromLincense;
      model.print_information_receipt_unit = this.normalizeBooleanValue(value);
      model.print_system_date = this.normalizeBooleanValue(cloneDbOptions.AddSystemDate);
      model.print_voucher_date = this.normalizeBooleanValue(cloneDbOptions.AddRefDate);
      model.allow_batch_printing = !this.normalizeBooleanValue(disableOptions.allow_batch_printing) && printPatch;
      model.print_voucher_preview = printPreview;
    }
  }
  /**
   * Lấy thông tin tùy chọn in để thực hiện in ngoài màn hình chứng từ
   * tbngoc 28.02.2023
   */
  handleBindSettingReportToPrint(refType, model, dbOptions, selected) {
    if (model) {
      let disableOptions = {};
      if (selected.disable_options) {
        disableOptions = JSON.parse(selected.disable_options);
      }
      const cloneDbOptions = _.cloneDeep(dbOptions);
      const printPatch = this.getLocalStorage('PrintBatch') == 'true';
      const printPreview = this.getLocalStorage('PrintPreview') == 'true';

      model.view_receipt_full_amount = this.normalizeBooleanValue(cloneDbOptions.IsGetEnoughMoney);
      let value = false;
      // Đã trao đổi với BA xong mới zem đoạn này
      // switch (refType) {
      //   case MSConstant.RefType.BUPlanWithdrawCash:
      //   case MSConstant.RefType.BUPlanWithdrawDeposit:
      //   case MSConstant.RefType.CAReceipt:
      //   case MSConstant.RefType.CAReceiptPlanWithdraw:
      //   case MSConstant.RefType.BADeposit:
      //   case MSConstant.RefType.BUTransferDeposit:
      //     value = cloneDbOptions.AddInfoFromLincense;
      //     break;
      //}

      value = cloneDbOptions.AddInfoFromLincense;
      model.print_information_receipt_unit = this.normalizeBooleanValue(value);

      model.print_system_date =
        !disableOptions.print_system_date && this.normalizeBooleanValue(cloneDbOptions.AddSystemDate);
      model.print_voucher_date =
        !disableOptions.print_voucher_date && this.normalizeBooleanValue(cloneDbOptions.AddRefDate);
      model.allow_batch_printing = !disableOptions.allow_batch_printing && this.normalizeBooleanValue(printPatch);
      model.print_voucher_preview = !disableOptions.print_voucher_preview && this.normalizeBooleanValue(printPreview);
    }
  }
  /**
   * Lấy thông tin tùy chọn in để thực hiện in tại màn hình chứng từ
   * tbngoc 28.02.2023
   */
  handleBindSettingReportToPrintInSettingLayout(refType, model, selected, currentOption) {
    if (model) {
      let disableOptions = {};
      if (selected.disable_options) {
        disableOptions = JSON.parse(selected.disable_options);
      }

      model.view_receipt_full_amount = currentOption.view_receipt_full_amount;
      let value = false;
      switch (refType) {
        case MSConstant.RefType.BUPlanWithdrawCash:
        case MSConstant.RefType.BUPlanWithdrawDeposit:
        case MSConstant.RefType.CAReceipt:
        case MSConstant.RefType.CAReceiptPlanWithdraw:
        case MSConstant.RefType.BADeposit:
        case MSConstant.RefType.BUTransferDeposit:
          value = currentOption.print_information_receipt_unit;
          break;
      }
      model.print_information_receipt_unit = value;

      model.print_system_date = !disableOptions.print_system_date && currentOption.print_system_date;
      model.print_voucher_date = !disableOptions.print_voucher_date && currentOption.print_voucher_date;
      model.allow_batch_printing = !disableOptions.allow_batch_printing && currentOption.allow_batch_printing;
      model.print_voucher_preview = !disableOptions.print_voucher_preview && currentOption.print_voucher_preview;
    }
  }

  normalizeBooleanValue(value) {
    if (typeof value === 'string') {
      return value == 'true';
    }
    return value;
  }

  containsSpecialChars(str) {
    const specialChars = /[`#'"]/;
    return specialChars.test(str);
  }

  /**
   * Lấy thời gian chênh lệch
   * @param {any} compareTime: Thời gian cần so sánh
   * Created by nnnam - 10/05/2022
   */
  getDifferenceTime(compareTime) {
    let now = moment(new Date());
    compareTime = moment(new Date(compareTime));
    let subTime = now - compareTime;
    let timeS = subTime / 1000;
    let timeM = timeS / 60;
    let timeH = timeM / 60;
    let timeD = timeH / 24;
    let result = '';

    if (timeS < 60) {
      result = 'Vừa xong';
    } else {
      let subDay = now.date() - compareTime.date();
      if (subDay == 0 && timeD < 1) {
        if (timeM < 60) {
          result = parseInt(timeM) + ' phút trước';
        } else {
          result = parseInt(timeH) + ' giờ trước';
        }
      } else if (timeD < 2 && [-30, -29, -28, -27, 1].includes(subDay)) {
        result = `Hôm qua lúc ${compareTime.format(MSConstant.Format.TimeNotSecond)}`;
      } else if (timeD > 1 && timeD < 7) {
        result = parseInt(timeD) + ' ngày trước';
      } else {
        result = compareTime.format(MSConstant.Format.DateNotSecond);
      }
    }

    return result;
  }

  /**
   * Lấy text lỗi ghi sổ khi chuyển đổi
   * nvtoan2 10/05/2023
   */
  getPostedConvertErrorText(postErrorData) {
    var errorMess = 'Ghi sổ lỗi. ';

    if (postErrorData && postErrorData?.Code.includes(';')) {
      errorMess +=
        'Thiếu thông tin: ' +
        postErrorData.Code.split(';')
          .map(x => {
            if (x) {
              return MSConstant.PostedErrorCode[x];
            }
            return null;
          })
          .filter(x => x)
          .join(', ');
    } else {
      if (postErrorData && postErrorData?.Code) {
        //TODO Các case ghi sổ khác
        switch (postErrorData?.Code) {
          case MSConstant.PostedErrorCode.Post_ValidQuantityToolCode:
            errorMess += 'Quá số tồn tại phòng ban của các vật tư trong chứng từ';
            break;
          case MSConstant.PostedErrorCode.Post_ValidateOutwardQuantityCode:
            errorMess += 'Không thể xuất vật tư, quá số tồn trong kho.';
            break;
          default:
            break;
        }
      } else {
        errorMess = '';
      }
    }

    return errorMess;
  }

  /**
   * show thông báo bảo trì
   * tvhien 14.06.2023
   */
  showAlertMaintaince(title) {
    const {Context} = store.state[ModuleContext];
    if (!Context?.IsBudgetPermission) {
      return showAlertEscapsed(
        'Bạn nên chạy chức năng <span class="bold" style="color: #0eac13">Bảo trì</span> để đảm bảo tính đúng đắn của dữ liệu.',
        [],
        title,
      );
    }
  }

  /**
   * Kiểm tra trạng thái chuyển đổi và mở form tương ứng
   * nvtoan2 19/06/2023
   */
  checkConvertStatuShowForm() {
    let isDisabled;
    const {Context} = store.state[ModuleContext];
    const {LastConvertQueue} = store.state[ModuleContext];
    const {TenantDatabases} = store.state[ModuleContext];

    // Nếu là dữ liệu chuyển đổi lỗi thì k cho làm việc
    let currentDb = TenantDatabases.find(x => x.database_id == Context.DatabaseId);
    if (currentDb && currentDb.status == MSConstant.DatabaseStatus.ConvertError) {
      popupUtil.show('ErrorWarningPopup', {});
      isDisabled = true;
    }

    // Nếu dl chuyển xong r thì bắt n đối chiếu thì mới cho làm việc
    // tạo một biến config để phòng trường hợp lỗi
    if (window._forceCompareConvert) {
      let compareInfo = JSON.parse(LastConvertQueue.compare_info);
      if (LastConvertQueue.status == MSConstant.ConvertDesktopStatus.Success && !compareInfo?.is_compared) {
        popupUtil.show('ConvertConfirmPopup', {convertInfo: LastConvertQueue});
        isDisabled = true;
      }
    }

    return isDisabled;
  }

  /**
   * Kiểm tra phiên bản tool convert đã đủ mới hay chưa
   * nvtoan2 27/12/2022
   */
  checkToolVersion(currentVersion) {
    let minVers = window._versionConvertTool.split('.');
    let currentVers = currentVersion?.split('.');

    if (!currentVers) {
      return false;
    }

    for (var i = 0; i < minVers.length; i++) {
      if (currentVers[i] == minVers[i]) {
        continue;
      }

      if (currentVers[i] > minVers[i]) {
        return true;
      }

      if (currentVers[i] < minVers[i]) {
        return false;
      }
    }

    return true;
  }

  /**
   * Viết riêng hàm group thành mảng
   * dqvinh 10.7.2023
   */
  groupByMapToArray = (input, key) => {
    return input.reduce((acc, currentValue) => {
      let groupKey = currentValue[key];
      if (!acc.find(x => x.key == groupKey)) {
        acc.push({key: groupKey, values: []});
      }
      acc.find(x => x.key == groupKey).values.push(currentValue);
      return acc;
    }, []);
  };

  /**
   * Kiểm tra service plugin đã mở chưa
   * nvtoan2 03/07/2023
   */
  pingServicePlugin() {
    let lstPort = MSConstant.ConvertDesktopPorts,
      portChecked,
      portOpen;

    lstPort.forEach(port => {
      drivenApi.port = port;
      drivenApi
        .ping()
        .then(res => {
          if (res) {
            drivenApi.port = port;
            portOpen = port;
          }
        })
        .catch(e => {
          portChecked++;
        });
    });

    if (portChecked == lstPort.length) {
      return false;
    } else {
      return portOpen;
    }
  }

  compareTime(time1, time2) {
    const [hours1, minutes1, seconds1] = time1.split(':');
    const [hours2, minutes2, seconds2] = time2.split(':');

    const date1 = new Date();
    date1.setHours(hours1, minutes1, seconds1);

    const date2 = new Date();
    date2.setHours(hours2, minutes2, seconds2);

    if (date1 < date2) {
      return -1;
    } else if (date1 > date2) {
      return 1;
    } else {
      return 0;
    }
  }

  /**
   * encode router param
   */
  encodeStr(value) {
    return window
      .btoa(encodeURIComponent(unescape(value)))
      ?.replaceAll('+', 'daucong')
      .replaceAll('/', 'daugachcheo')
      .replaceAll('=', 'daubang')
      .replaceAll('&', 'dauva');
  }

  removeFileExtension(fileName) {
    return fileName?.replace(/\.[^.]+$/, '');
  }

  /**
   * Kiểm tra quyền truy cập route
   * @param {*} toRouter
   * nmtuan4 26.10.2023
   */
  async checkPermissionRouter(toRouter) {
    const {Context} = store.state[ModuleContext];

    if (!Context?.DatabaseId) {
      return true;
    }

    if (toRouter.path) {
      let dbOptions = await store.dispatch('dbOption/getDbOptions');

      if ((toRouter.path.contains('treasury') || toRouter.path.contains('etreasury')) && !dbOptions.UseBudget) {
        return false;
      }

      if ((toRouter.path.contains('asset') || toRouter.path.contains('assetqlts')) && !dbOptions.UseFixAsset) {
        return false;
      }

      if (toRouter.path.contains('cash') && !dbOptions.UseCA) {
        return false;
      }

      if (toRouter.path.contains('deposits') && !dbOptions.UseBA) {
        return false;
      }

      if (toRouter.path.contains('inventory') && !dbOptions.UseWarehouse && !toRouter.path.contains('dictionary')) {
        return false;
      }

      if (toRouter.path.contains('tools') && !dbOptions.UseSupply) {
        return false;
      }

      if (toRouter.path.contains('salary') && !dbOptions.UseSalary) {
        return false;
      }

      if (toRouter.path.contains('purchase') && !dbOptions.UsePurchase) {
        return false;
      }

      if (toRouter.path.contains('sell') && !dbOptions.UseSale) {
        return false;
      }

      if (toRouter.path.contains('invoice') && !dbOptions.Invoice) {
        return false;
      }

      if (toRouter.path.contains('tax') && !dbOptions.UseTA) {
        return false;
      }

      if (toRouter.path.contains('summary') && !dbOptions.UseGL) {
        return false;
      }

      if (toRouter.path.contains('dictionary/task') && !dbOptions.UseTask) {
        return false;
      }

      if (
        (toRouter.path.contains('dictionary/invoiceFormNumber') ||
          toRouter.path.contains('dictionary/purchasePurpose')) &&
        !dbOptions.UseTA
      ) {
        return false;
      }

      if (toRouter.path.contains('dictionary/topic') && !dbOptions.UseTopicManagement) {
        return false;
      }

      if (toRouter.path.contains('dictionary/project') && !dbOptions.UseProjectManagement) {
        return false;
      }

      if (toRouter.path.contains('dictionary/budgetprovide') && !dbOptions.IsDetailbyBudgetProvidence) {
        return false;
      }

      if (toRouter.path.contains('dictionary/contract') && !dbOptions.UseContract) {
        return false;
      }

      if (toRouter.path.contains('dictionary/fundStructure') && !dbOptions.UseInvestorAccounting) {
        return false;
      }

      if (
        (toRouter.path.contains('dictionary/fixedasset') || toRouter.path.contains('dictionary/fixedassetcategory')) &&
        !dbOptions.UseFixAsset
      ) {
        return false;
      }

      if (
        (toRouter.path.contains('dictionary/salaryScale') ||
          toRouter.path.contains('dictionary/employeeType') ||
          toRouter.path.contains('dictionary/salaryScale')) &&
        !dbOptions.UseSalary
      ) {
        return false;
      }
    }
    return true;
  }

  /**
   * Sort dữ liệu object theo order
   * nvtoan2 13/11/2023
   */
  sortData(data, sortStr) {
    try {
      let result = data;
      let sorts = sortStr?.split(',');

      if (sorts?.length > 0) {
        result = result.sort((a, b) => {
          let index = 0;

          while (index < sorts.length) {
            if (index == sorts.length) return 0;

            let sort = sorts[index],
              blankIndex = sort?.indexOf(' '),
              field = blankIndex ? sort.substr(0, blankIndex) : sort,
              dir = blankIndex ? sort.substr(blankIndex + 1) : '';

            if (a[field] === b[field]) {
              index++;
            } else {
              if (dir.toLowerCase() === 'desc') {
                return a[field].localeCompare(b[field]) * -1;
              }

              // Mặc định là tăng dần
              return a[field].localeCompare(b[field]);
            }
          }
        });
      }

      return result;
    } catch (e) {
      console.log('Có lỗi khi sort' + e);

      return data;
    }
  }
  /**
   * Kiểm tra nếu chưa khởi tạo dữ liệu redirect
   *
   */
  checkHasDatabaseID(toRouter) {
    const {Context} = store.state[ModuleContext];
    let databaseId = Context?.DatabaseId;
    const router = useRouter();
    if (
      !databaseId &&
      !toRouter.path.contains('/logout') &&
      !toRouter.path.contains('/getting-method') &&
      !toRouter.path.contains('/create-data-tenant') &&
      !toRouter.href.includes('/choose-tenant') &&
      !toRouter.href.includes('/license-expire-date')
    ) {
      router.push('/system/getting-method');
    }
  }

  /**
   * Xóa lịch sử scroll của 1 file pdf đã mở
   * @param {*} key giá trị key
   * nvtoan2 19/12/2023
   */
  removeCachePDFHistory(key) {
    try {
      let pdfHistory = JSON.parse(localStorage.getItem('pdfjs.history')),
        filterHis = pdfHistory?.files?.filter(x => x?.fingerprint !== key);

      if (filterHis?.length > 0) {
        pdfHistory.files = filterHis;
        localStorage.setItem('pdfjs.history', JSON.stringify(pdfHistory));
      } else {
        localStorage.removeItem('pdfjs.history');
      }
    } catch (e) {
      console.log('Lỗi khi xóa cache scroll pdf');
    }
  }

  /**
   * Xóa lịch sử link click của 1 file pdf đã mở
   * @param {*} key giá trị key
   * nvtoan2 19/12/2023
   */
  removeCachePDFLinkClick(keyPrint) {
    try {
      let pdfLinkClicks = JSON.parse(localStorage.getItem('pdfjs.linkClick')),
        filterLink = pdfLinkClicks?.filter(x => x?.key != keyPrint);

      if (value) {
        filterLink = filterLink?.filter(x => x.linkId != value);
      }

      localStorage.setItem('pdfjs.linkClick', JSON.stringify(filterLink));
    } catch (e) {
      console.log('Lỗi khi xóa cache link pdf');
    }
  }

  /**
   * Xóa trạng thái render của file PDF
   * @param {*} key giá trị key
   * nvtoan2 02/01/2023
   */
  removeCachePDFLoading(keyPrint) {
    let pdfjsLoading = localStorage.getItem('pdfjsLoading');

    if (keyPrint && pdfjsLoading) {
      let loading = JSON.parse(pdfjsLoading);
      if (loading instanceof Array && loading?.length > 0) {
        localStorage.setItem('pdfjsLoading', JSON.stringify(loading?.filter(x => x !== keyPrint)));
      }
    }
  }

  /**
   * kiểm tra báo cáo có in theo luồng bất đồng bộ không
   * @param {*} reportParam tham số in báo cáo
   * nqhuy1 10/01/2024
   */
  checkIsPrintAsync(reportParam) {
    const reportId = reportParam.reportId ?? reportParam.ReportId ?? reportParam.report_id;
    const isPrintAsync = window._staticReportPrintWorker?.includes(reportId);
    return isPrintAsync;
  }

  /**
   * Có in bìa báo cáo hay không lấy từ dbOption và config env
   * HMDUC2 23/02/2024
   */
  isPrintCoverReport(reportParam) {
    const reportId = reportParam.reportId ?? reportParam.ReportId ?? reportParam.report_id;
    let dbOptions = {...store.state[ModuleDbOption]?.dbOptions};
    var isPrintCover = dbOptions?.PrintReportCover && window._newPrintCover?.includes(reportId);
    return isPrintCover;
  }

  /**
   * gọi interval pulling, config thời gian delay theo số lần gọi
   * @param {*} arrayConfig vd: [{timeCount: 10, timeDelay:1000}, {timeCount: 20, timeDelay: 5000}]
   * @param {*} callbackWhenSuccessAsync hàm thực thi khi callbackCheckSuccessAsync trả về true
   * @param {*} callbackCheckSuccessAsync hàm kiểm tra thành công
   * @param {*} callbackCheckCancelAsync hàm kiểm tra hủy interval
   * nqhuy1 10/1/2024
   */
  intervalPulling(
    arrayConfig,
    callbackWhenSuccessAsync,
    callbackCheckSuccessAsync,
    callbackCheckCancelAsync = async () => false,
  ) {
    let timeCount = 0;
    let interval = null;
    function createInterval(timeDelay) {
      interval = setInterval(async () => {
        timeCount++;

        // kiểm tra hủy interval
        const isCancel = await callbackCheckCancelAsync();
        if (isCancel) {
          clearInterval(interval);
        }
        // kiểm tra thành công
        const isSuccess = await callbackCheckSuccessAsync();
        if (isSuccess) {
          clearInterval();
          await callbackWhenSuccessAsync();
        }

        // lấy ra config hiện tại theo số lần gọi
        const itemConfig = arrayConfig.find(item => item.timeCount > timeCount);

        if (itemConfig) {
          // trường hợp mốc time delay thay đổi thì clear interval cũ và tạo interval mới
          if (itemConfig.timeDelay != timeDelay) {
            clearInterval(interval);
            createInterval(itemConfig.timeDelay);
          }
        }
        // trường hợp quá số lần gọi thì hủy interval
        else {
          clearInterval(interval);
        }
      }, timeDelay);
    }

    createInterval(arrayConfig[0].timeDelay);
    return () => clearInterval(interval);
  }

  getBrowserTitle(code) {
    if (!code) {
      return null; // mở popup mà không làm thay đổi title thì nó rơi vào case này
    }

    const localize = i18n;
    const screenName = localize.t(`i18nMonitor.BrowserTitle.${code}`);

    if (!screenName) {
      console.error('Chưa định nghĩa screenName tại i18n');
      return ''; // chưa config sources thì trả về tiêu đề mặc định
    }

    return screenName.replace('__', `|`);
  }

  /**
   * Cập nhật title page khi mở màn hình
   */
  updateBrowserTitleWhenOpenScreen(titleCode, objectCode) {
    if (!titleCode) return;

    if (titleCode.startsWith('detail_') && (objectCode == null || objectCode == undefined)) return;

    // const {_cacheTitlePage} = window;
    if (!Array.isArray(window._cacheTitlePage)) return;

    let titlePage = this.getBrowserTitle(titleCode);

    if (!titlePage) return;

    let item = {
      titleCode: titleCode,
      objectCode: objectCode,
      perentPath: '',
      fullTitle: '',
    };

    if (objectCode != null && objectCode != undefined) {
      const lastIndex = window._cacheTitlePage.length - 1;

      item.perentPath = window._cacheTitlePage[lastIndex]?.perentPath;

      if (objectCode != '') titlePage = `${titlePage} ${objectCode} | ${item.perentPath}`;
      else titlePage = `${titlePage} | ${item.perentPath}`;
    } else {
      item.perentPath = titlePage;
    }

    window._cacheTitlePage = window._cacheTitlePage.filter(i => i.titleCode !== titleCode); // lọc bỏ những page trong queu cùng mã với page này

    item.fullTitle = this.getFormatTitlePage(titlePage);
    window._cacheTitlePage.push(item); // đẩy vào queu

    document.title = item.fullTitle; // lại lại tiêu đề trình duyệt
  }

  /**
   * Cập nhật title page khi đóng màn hình
   */
  updateBrowserTitleWhenCloseScreen(titleCode, objectCode) {
    if (!titleCode) return;

    if (titleCode.startsWith('detail_') && (objectCode == null || objectCode == undefined)) return;

    // const {_cacheTitlePage} = window;
    if (!Array.isArray(window._cacheTitlePage)) return;

    let titlePage = this.getBrowserTitle(titleCode);

    if (!titlePage) return;

    // if (objectCode)
    //   titlePage = `${titlePage} ${objectCode}`;

    // const fullTitle = this.getFormatTitlePage(titlePage);

    const lastIndex = window._cacheTitlePage.length - 1;

    // Nếu index cuối cùng chứa title hiện tại của screen
    if (
      lastIndex >= 0 &&
      window._cacheTitlePage[lastIndex] &&
      window._cacheTitlePage[lastIndex].titleCode === titleCode
    ) {
      window._cacheTitlePage.pop();

      const titlePage = window._cacheTitlePage[lastIndex - 1];

      if (titlePage) {
        document.title = titlePage.fullTitle;
      }
    }
  }

  getFormatTitlePage(pageTitle) {
    const {Context} = store.state[ModuleContext];

    let title = '';

    if (!pageTitle) {
      title = `Mimosa Online`;
    } else if (!Context || !Context.isMultipleTenant) {
      title = `${this.getValueOrDefault(pageTitle)} | Mimosa Online`;
    } else {
      const companyName = Context.TenantName;
      title = `${this.getValueOrDefault(pageTitle)} | ${companyName} | Mimosa Online`;
    }

    return title
      .trim()
      .replace('| |', '|')
      .replace(/^\|+|\|+$/g, ''); // lọc các ký tự | | thừa
  }

  getValueOrDefault(name) {
    return name?.trim() ?? '';
  }

  /**
   * Xử lý mã số thuế NSD nhập về đúng cấu trúc
   * dtnga3 (05.03.2024)
   */
  getTaxCode(code) {
    if (!code) {
      return '';
    }
    code = code.trim();
    if (code.length < 13) {
      return code;
    } else {
      let subCode = code.substring(code.length - 3, code.length).trim();
      let firstPartCode = code.substring(0, code.length - 3).trim();
      return (firstPartCode.length == 10 ? firstPartCode : firstPartCode.substring(0, 10)) + '-' + subCode;
    }
  }

  /**
   * Lấy message đã đc escapse xss cho message box
   */
  getMessageEscapsed(resourceText, paramMessage) {
    if (!resourceText) throw 'Not found resource';
    if (!Array.isArray(paramMessage)) throw 'param message is not array!';
    const escapseParam = paramMessage.map(x => this.processXssValue(x));
    const message = resourceText.format(...escapseParam);
    return message;
  }

  /**
   * Hàm lấy phụ lục giảm thuế theo kỳ và năm tính thuế
   * NHANH3 25.06.2024
   * Modified HMDUC2 30.09.2024 Sửa lại mã phụ lục 142
   */
  getTaxReductionAppendix(period, year, code) {
    let taxReductionAppendixs = [
      {
        appendix_code: 'PLNQ43/2022/QH15', // Mã phụ lục giảm thuế
        appendix_type: MSConstant.VatAppendixType.Ta432022QH15, // Loại phụ lục giảm thuế
        contentTitle: '43/2022/QH15', // Tên phụ lục trên màn nội dung
        titleTabRedution: 'PL NQ43/2022/QH15', // Tên phục lục trên tab
        appendix_name: 'Giảm thuế giá trị gia tăng theo Nghị quyết 43/2022/QH15', // Tên phụ lục
        fromDate: new Date(2023, 0), // Thời gian bắt đầu
        toDate: new Date(2023, 4), // Thời gian hết hiệu lực
      },
      {
        appendix_code: 'PLNQ101/2023/QH15',
        appendix_type: MSConstant.VatAppendixType.TaPL1102023QH15,
        contentTitle: '101/2023/QH15',
        titleTabRedution: 'PLNQ101/2023/QH15',
        appendix_name: 'Giảm thuế giá trị gia tăng theo Nghị quyết số 101/2023/QH15',
        fromDate: new Date(2023, 5),
        toDate: new Date(2023, 11),
      },
      {
        appendix_code: 'PL_GiamThue_GTGT_23_24',
        appendix_type: MSConstant.VatAppendixType.TaPL1012023QH15,
        contentTitle: '110/2023/QH15',
        titleTabRedution: 'PL_GiamThue_GTGT_23_24',
        appendix_name: 'Giảm thuế giá trị gia tăng theo Nghị quyết số 110/2023/QH15',
        fromDate: new Date(2024, 0),
        toDate: new Date(2024, 5),
      },
      {
        appendix_code: 'PL 142/2024/QH15',
        appendix_type: MSConstant.VatAppendixType.TaPL1422024QH15,
        contentTitle: '142/2024/QH15',
        titleTabRedution: 'PL 142/2024/QH15',
        appendix_name: 'Giảm thuế giá trị gia tăng theo Nghị quyết số 142/2024/QH15',
        fromDate: new Date(2024, 6),
        toDate: new Date(2024, 11),
      },
    ];

    // Lấy theo code trước nếu code null thì lấy theo kỳ và năm
    if (code) {
      return taxReductionAppendixs.find(x => x.appendix_code == code);
    }

    if (!period || !year) {
      return null;
    }

    let month = period;
    switch (period) {
      case 101:
        month = 3;
        break;
      case 102:
        month = 6;
        break;
      case 103:
        month = 9;
        break;
      case 104:
        month = 12;
        break;
    }
    let dateTime = new Date(year, month - 1); // trừ 1 vì tháng bắt đầu từ 0

    return taxReductionAppendixs.find(x => new Date(dateTime) >= x.fromDate && new Date(dateTime) <= x.toDate);
  }

  /**
   * Hàm lấy câu thông báo lỗi từ error code trả ra từ tool ký số lỗi
   * PTHA 09.07.2024
   */
  getErrorMessageMisaKyso(errorCode) {
    let result;
    switch (errorCode) {
      case 'NoCertificate':
        result =
          'Không có chứng thư nào được chọn hoặc danh sách chứng thư trống. Vui lòng chọn chứng thư số để thực hiện ký số.';
        break;
      case 'BuyerSigned':
      case 'SignedError':
      case 'CancelSession':
      case 'FileHasInvalidSignature':
      case 'WrongSecureTokenKey':
      case 'SerialNumberNotExits':
      case 'Exception':
      case 'UnhandledException':
        result = 'Có lỗi trong quá trình ký. Vui lòng liên hệ với MISA để được hỗ trợ.';
        break;
      case 'SourceNotFound':
        result = ' Hiện tại không có tài liệu nào để ký. Vui lòng kiểm tra lại.';
        break;
      case 'NotFoundCertificate':
        result = 'Không tìm thấy chứng thư số. Vui lòng kiểm tra lại USB của đơn vị.';
        break;
      case 'NotExitsSerialNumber':
      case 'USBNotConnect':
        result = 'Không tìm thấy chứng thư số. Vui lòng kiểm tra lại USB của đơn vị.';
        break;
      case 'CertificateIsNotValid':
        result = 'Chứng thư số đã hết hạn hoặc bị thu hồi. Vui lòng chọn chứng thư số còn hạn để ký số.';
        break;
      case 'StorageIsEmpty':
        result = 'Không tìm thấy chứng thư số hợp lệ. Vui lòng kiểm tra lại.';
        break;
      case 'NotSupportRemoteSigningCert':
        result = 'Chứng thư số chưa hợp lệ. Vui lòng chọn lại chứng thư số để thực hiện ký số.';
        break;
      case 'NotSupportDocumentType':
        result = ' Phần mềm không hỗ trợ định dạng tệp tải lên';
        break;
      case 'NotSupportAlgorithm':
        result = 'Chương trình chưa hỗ trợ ký số cho chữ ký số này. Vui lòng chọn lại chữ ký số khác.';
        break;
      case 'TaxCodeInValid':
        result = 'Mã số thuế của chứng thư số không khớp với mã số thuế trên hóa đơn điện tử. Vui lòng kiểm tra lại.';
        break;
      case 'IncorrectPIN':
        result = 'Mã PIN không chính xác. Vui lòng kiểm tra lại.';
        break;
      case 'TokenExprireDate':
        result = 'Chứng thư số đã hết hạn hoặc bị thu hồi. Vui lòng chọn chứng thư số còn hạn để ký số.';
        break;
      case 'TokenRevoke':
        result = 'Chứng thư số đã hết hạn hoặc bị thu hồi. Vui lòng chọn chứng thư số còn hạn để ký số';
        break;
      default:
        result = null;
        break;
    }
    return result;
  }
  getUrlEmbebed(path) {
    const date = new Date();
    const cdn = window._cdnsite ? window._cdnsite : '';
    if (!path) return '';
    const hash = window._ui_version ? window._ui_version : `${date.getDay()}_${date.getMonth()}_${date.getFullYear()}`;

    return `${cdn}${path}?v=${hash}`;
  }

  /**
   * Chuyển đến url mới
   * @param {*} url
   * NVTUAN1 27.11.2024
   */
  redirectToUrl(url) {
    if (url) {
      location.href = url;
    } else {
      location.href = '/';
    }
  }
}

export default new CommonFunction();



